import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Card,
  Button,
  Table,
  CardBody,
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  InputGroupAddon,
  InputGroupText,
  Input,
  InputGroup,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Modal,
  ModalHeader,
  ModalBody,
  CardTitle,
  CardHeader,
  Label,
  Alert,
} from "reactstrap";

import * as XLSX from "xlsx";

import "react-calendar/dist/Calendar.css";
import { api } from "../../../../api";
import { Link } from "react-router-dom";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import Cookies from "js-cookie";

const Storemanagement4 = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [projectDropdownOpen, setProjectDropdownOpen] = useState(false);
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [addStockDropdownOpen, setAddStockDropdownOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [selectedDeliveryProject, setSelectedDeliveryProject] = useState("");
  const [selectedReturnProject, setSelectedReturnProject] = useState("");
  const [deliveryProjectDropdownOpen, setDeliveryProjectDropdownOpen] =
    useState(false);
  const [returnProjectDropdownOpen, setReturnProjectDropdownOpen] =
    useState(false);
  const [projects, setProjects] = useState([]);
  // const [deliveryProductDropdownOpen, setDeliveryProductDropdownOpen] = useState(false);
  // const [returnProductDropdownOpen, setReturnProductDropdownOpen] = useState(false);

  const [addStockMessage, setAddStockMessage] = useState({
    type: "",
    text: "",
  });

  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [alertType, setAlertType] = useState("success"); // "success" or "error"

  useEffect(() => {
    const fetchData = async () => {
      try {
        const company_id = Cookies.get('company_id');
        const response = await api.get(`viewitemsSTM.php?company_id=${company_id}`);
        const products = response.data.products;
        setOriginalData(products); // Store original data
        setFilteredData(products); // Initially set filtered data to original data
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const [itemToDelete, setItemToDelete] = useState(null);

  const handleDeleteIconClick = (item_id) => {
    setItemToDelete(item_id);
    setShowDeleteConfirmation(true);
  };

  const handleDeleteConfirmation = async () => {
    try {
      const company_id = Cookies.get('company_id');
      const response = await api.delete(`deleteitemsSTM.php`, {
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify({ 
          product_id: itemToDelete,
          company_id: company_id 
        }),
      });
      if (response.data && response.data.status === "success") {
        setSuccessMessage("Stock deleted successfully!");
        setShowSuccessAlert(true);
        setTimeout(() => {
          setShowSuccessAlert(false);
          window.location.reload();
        }, 1500);
      } else {
        setAddStockMessage({ type: "danger", text: response.data?.error || "Failed to delete stock." });
      }
    } catch (error) {
      console.error("Delete error:", error);
      setAddStockMessage({ type: "danger", text: error.response?.data?.error || "Failed to delete stock." });
    }
    setItemToDelete(null);
    setShowDeleteConfirmation(false);
  };

  const [showRoleModal, setShowRoleModal] = useState(false);
  const [showRoleModal2, setShowRoleModal2] = useState(false);
  const [showRoleModal3, setShowRoleModal3] = useState(false);
  const toggleRole = () => {
    setShowRoleModal(!showRoleModal);
  };
  const toggleRole2 = () => {
    setShowRoleModal2(!showRoleModal2);
  };
  const toggleRole3 = () => {
    if (!showRoleModal3) {
      // Reset form when opening modal
      setAddStock3({
        p_id: "",
        product_name: "",
        quantity_returned: "",
        yet_to_returned: "",
        return_date: "",
        returned_by: "",
        material_tracking_number: "",
      });
      setSelectedProductProjects([]);
      setSelectedProjectTracking([]);
      setSelectedDeliveryInfo(null);
    }
    setShowRoleModal3(!showRoleModal3);
  };

  const toggleAddStockDropdown = () => {
    setAddStockDropdownOpen(!addStockDropdownOpen);
  };

  const handleAddStockOption = (option) => {
    if (option === 'single') {
      toggleRole();
    } else if (option === 'multiple') {
      toggleModalImport();
    }
    setAddStockDropdownOpen(false);
  };

  const [role, setrole] = useState();

  const [viewrole, setviewrole] = useState();
  const [loading, setLoading] = useState(true);

  const [entriesToShow, setEntriesToShow] = useState(5);
  const [dataToShow, setDataToShow] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(filteredData.length / entriesToShow);

  useEffect(() => {
    setDataToShow(
      filteredData.slice(
        (currentPage - 1) * entriesToShow,
        currentPage * entriesToShow
      )
    );
  }, [entriesToShow, currentPage, filteredData]);

  const toggleProjectDropdown = () => {
    setProjectDropdownOpen(!projectDropdownOpen);
  };

  const handleEntriesChange = (value) => {
    setEntriesToShow(value === "All" ? filteredData.length : Number(value));
    setCurrentPage(1);
  };

  const prePage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const nextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const changeCPage = (n) => {
    setCurrentPage(n);
  };

  const handleDownload = () => {
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";
    const fileName = "stock_list";

    const formattedData = filteredData.map((item) => ({
      // "Product Id": item.product_id,
      "Product Name": item.product_name,

      "Current Stock(Quantity)": item.available_stock,
      "Total Stock": item.total_stock,
      Cost: item.cost,
    }));

    const ws = XLSX.utils.json_to_sheet(formattedData, {
      header: [
        // "Product Id",
        "Product Name",
        "Current Stock(Quantity)",
        "Total Stock",
        "Cost",
      ],
    });

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Stock List");

    const headerCellStyle = {
      font: { bold: true },
      fill: { bgColor: { indexed: 64 } },
    };
    Object.keys(ws)
      .filter((key) => key.startsWith("A1"))
      .forEach((key) => {
        ws[key].s = headerCellStyle;
      });

    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });

    const excelData = new Blob([excelBuffer], { type: fileType });

    const excelUrl = URL.createObjectURL(excelData);

    const link = document.createElement("a");
    link.href = excelUrl;
    link.download = fileName + fileExtension;
    document.body.appendChild(link);
    link.click();

    setTimeout(function () {
      document.body.removeChild(link);
      window.URL.revokeObjectURL(excelUrl);
    }, 100);
  };

  const [addstock, setAddStock] = useState({
    product_name: "",
    total_stock: 0,
    available_stock: 0,
    cost: "",
  });

  const [addstock2, setAddStock2] = useState({
    p_id: "",
    product_name: "",
    quantity_delivered: "",
    delivery_date: "",
    delivered_to_name: "",
    product_cost: "",
    material_tracking_number: "",
  });

  const [addstock3, setAddStock3] = useState({
    p_id: "",
    product_name: "",
    quantity_returned: "",
    yet_to_returned: "",
    return_date: "",
    returned_by: "",
    material_tracking_number: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setAddStock((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    setAddStock2((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    setAddStock3((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    console.log("Updated form data:", { ...addstock, [name]: value }); // Debug log
  };

  const handleFormSubmit = async (event) => {
    event.preventDefault();
    
    // Frontend validation to prevent negative numbers
    if (parseFloat(addstock.total_stock) < 0 || parseFloat(addstock.available_stock) < 0 || parseFloat(addstock.cost) < 0) {
      setAddStockMessage({ type: "danger", text: "Stock quantities and cost cannot be negative numbers!" });
      return;
    }
    
    // Validate that available stock doesn't exceed total stock
    if (parseFloat(addstock.available_stock) > parseFloat(addstock.total_stock)) {
      setAddStockMessage({ type: "danger", text: "Available stock cannot exceed total stock!" });
      return;
    }
    
    const company_id = Cookies.get('company_id');
    const formDataToSend = {
      product_name: addstock.product_name,
      total_stock: addstock.total_stock,
      available_stock: addstock.available_stock,
      cost: addstock.cost,
      company_id: company_id,
    };
    try {
      const response = await api.post(`additemsSTM.php?company_id=${company_id}`, formDataToSend);
      if (response.data && response.data.status === "success") {
        // Show different messages based on whether product was created or updated
        if (response.data.action === "updated") {
          setSuccessMessage(`Product stock updated successfully! Previous stock: ${response.data.previous_available_stock}, New stock: ${response.data.new_available_stock}`);
        } else {
          setSuccessMessage("New product added successfully!");
        }
        setShowSuccessAlert(true);
        setTimeout(() => {
          setShowSuccessAlert(false);
          window.location.reload();
        }, 1500);
      } else {
        setAddStockMessage({ type: "danger", text: "Failed to add stock." });
      }
    } catch (error) {
      setAddStockMessage({ type: "danger", text: "Failed to add stock." });
    }
  };

  const handleFormSubmit2 = async (event) => {
    event.preventDefault();

    // Validate all required fields
    if (
      !addstock2.p_id ||
      !addstock2.product_name ||
      !addstock2.quantity_delivered ||
      !addstock2.delivery_date ||
      !addstock2.delivered_to_name ||
      !addstock2.product_cost ||
      !addstock2.material_tracking_number
    ) {
      alert("Please fill in all required fields.");
      return;
    }

    // Frontend validation to prevent negative numbers
    if (parseFloat(addstock2.quantity_delivered) <= 0) {
      alert("Quantity delivered must be greater than 0!");
      return;
    }
    
    if (parseFloat(addstock2.product_cost) < 0) {
      alert("Product cost cannot be negative!");
      return;
    }

    const company_id = Cookies.get('company_id');
    const formDataToSend = {
      p_id: parseInt(addstock2.p_id),
      product_name: addstock2.product_name,
      quantity_delivered: parseInt(addstock2.quantity_delivered),
      delivery_date: addstock2.delivery_date,
      delivered_to_name: addstock2.delivered_to_name,
      product_cost: parseFloat(addstock2.product_cost),
      material_tracking_number: addstock2.material_tracking_number,
      company_id: company_id, // Add company_id to POST body
    };

    // Debug log to check what is being sent
    console.log('DELIVERY SUBMIT DEBUG:', {
      company_id,
      product_name: addstock2.product_name,
      p_id: addstock2.p_id,
      formDataToSend
    });

    try {
      const response = await api.post(`crudDeliveryStock.php?company_id=${company_id}`, formDataToSend);
      if (response.data && (response.data.status === "success" || response.data.message)) {
        setSuccessMessage(response.data.message || "Material delivered successfully!");
        setShowSuccessAlert(true);
        setTimeout(() => {
          setShowSuccessAlert(false);
          window.location.reload();
        }, 1500);
      } else if (response.data.error) {
        setAddStockMessage({ type: "danger", text: response.data.error });
      }
    } catch (error) {
      console.error("Delivery error:", error);
      setAddStockMessage({ type: "danger", text: error.response?.data?.error || "Error submitting delivery data." });
    }
  };

  useEffect(() => {
    if (searchQuery === "") {
      setFilteredData(originalData);
    } else {
      const trimmedQuery = searchQuery.trim();
      const filteredResults = originalData.filter(
        (item) =>
          item.product_name &&
          item.product_name.toLowerCase().includes(trimmedQuery.toLowerCase())
      );
      setFilteredData(filteredResults);
    }
  }, [searchQuery, originalData]);
  console.log(dataToShow);

  const [projectDropdownOpen2, setProjectDropdownOpen2] = useState(false);

  const toggleProjectDropdown2 = () => {
    setProjectDropdownOpen2(!projectDropdownOpen2);
  };

  const handleRequestOptionChange = (e) => {
    setRequestOption(e.target.value);
    if (e.target.value === "single") {
      toggleRole();
    } else if (e.target.value === "multiple") {
      toggleModalImport();
    }
  };
  const [requestOption, setRequestOption] = useState("");
  const toggleModalAdd = () => setModalAdd(!modalAdd);
  const [modalAdd, setModalAdd] = useState(false);
  const [importedFile, setImportedFile] = useState(null);
  const emp_id = Cookies.get("token") || Cookies.get("emp_id");

  const [reqmaterial, setReqmaterial] = useState({
    emp_id: emp_id || "",
    p_id: "",
    files: [],
    g_m_id: "",
  });

  const handleImportFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFile(file);
      setImportedFileDetails({
        fileName: file.name,
        uploadTime: new Date().toLocaleTimeString(),
      });
      setUploadMessage({ type: "", text: "" }); // Clear previous messages
    } else {
      setSelectedFile(null);
      setImportedFileDetails(null);
    }
  };

  const [modalImport, setModalImport] = useState(false); // State to control modal visibility
  const [selectedFile, setSelectedFile] = useState(null); // State to hold the File object
  const [importedFileDetails, setImportedFileDetails] = useState(null); // State for display info
  const [isUploading, setIsUploading] = useState(false); // State for loading indicator
  const [uploadMessage, setUploadMessage] = useState({ type: "", text: "" }); // State for feedback

  const toggleModalImport = () => {
    setModalImport(!modalImport);
    // Reset states when closing modal
    if (modalImport) {
      setSelectedFile(null);
      setImportedFileDetails(null);
      setUploadMessage({ type: "", text: "" });
      setIsUploading(false);
    }
  };

  // Handle file selection

  // Handle form submission
  const handleImportSubmit = async (event) => {
    event.preventDefault();
    if (!selectedFile) {
      setUploadMessage({
        type: "danger",
        text: "Please select a file to import.",
      });
      return;
    }
    setIsUploading(true);
    setUploadMessage({
      type: "primary",
      text: "Uploading and processing file...",
    });
    const company_id = Cookies.get('company_id');
    console.log('Company ID from cookie:', company_id); // Debug log
    const formData = new FormData();
    formData.append('company_id', company_id);
    formData.append("excel_file", selectedFile);
    
    // Debug: Log FormData contents
    for (let [key, value] of formData.entries()) {
      console.log('FormData entry:', key, value);
    }
    
    try {
      const response = await api.post(`importExcelSTM.php`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        params: { company_id: company_id }, // still send as query param for compatibility
      });
      if (response.data && response.data.status === "success") {
        // Create detailed message with success/error counts
        const results = response.data.results || {};
        const totalSuccess = results.total_success || 0;
        const totalErrors = results.total_errors || 0;
        const totalProcessed = results.total_processed || 0;
        
        let detailedMessage = response.data.message || "Stocks imported successfully!";
        
        // Add details about skipped rows if any (legacy support)
        if (response.data.skipped_rows && response.data.skipped_rows.length > 0) {
          detailedMessage += ` Skipped ${response.data.skipped_rows.length} rows with invalid data.`;
        }
        if (response.data.updated_ids && response.data.updated_ids.length > 0) {
          detailedMessage += ` Updated ${response.data.updated_ids.length} existing products with additional stock.`;
        }
        
        if (totalProcessed > 0) {
          detailedMessage += `\n\n📊 Upload Summary:\n`;
          detailedMessage += `✅ Successfully uploaded: ${totalSuccess} records\n`;
          detailedMessage += `❌ Failed: ${totalErrors} records\n`;
          detailedMessage += `📋 Total processed: ${totalProcessed} records`;
          
          // Add error details if there are errors
          if (totalErrors > 0 && results.errors && results.errors.length > 0) {
            detailedMessage += `\n\n❌ Error Details:\n`;
            results.errors.forEach((error, index) => {
              detailedMessage += `${index + 1}. Row ${error.row}: ${error.error}\n`;
            });
          }
        }
        
        setSuccessMessage(detailedMessage);
        setAlertType("success");
        setShowSuccessAlert(true);
        setTimeout(() => {
          setShowSuccessAlert(false);
          window.location.reload();
        }, 2000);
      } else {
        setSuccessMessage(`Import failed: ${response.data.message || "Unknown error from server."}`);
        setAlertType("error");
        setShowSuccessAlert(true);
      }
    } catch (error) {
      setSuccessMessage(`An error occurred during upload: ${error.message}`);
      setAlertType("error");
      setShowSuccessAlert(true);
    } finally {
      setIsUploading(false);
    }
  };

  // Add these state declarations after your existing state declarations
  const [materialDeliveryData, setMaterialDeliveryData] = useState([]);
  const [filteredMaterialDeliveryData, setFilteredMaterialDeliveryData] =
    useState([]);
  const [deliveryEntriesToShow, setDeliveryEntriesToShow] = useState(5);
  const [deliveryCurrentPage, setDeliveryCurrentPage] = useState(1);
  const [deliveryShowEntriesDropdownOpen, setDeliveryShowEntriesDropdownOpen] =
    useState(false);

  const [vendorReturnData, setVendorReturnData] = useState([]);
  const [filteredVendorReturnData, setFilteredVendorReturnData] = useState([]);
  const [returnEntriesToShow, setReturnEntriesToShow] = useState(5);
  const [returnCurrentPage, setReturnCurrentPage] = useState(1);
  const [returnShowEntriesDropdownOpen, setReturnShowEntriesDropdownOpen] =
    useState(false);

  // New state variables for Material Delivery filters
  const [selectedDeliveryProduct, setSelectedDeliveryProduct] = useState("");
  const [deliveryStartDate, setDeliveryStartDate] = useState("");
  const [deliveryEndDate, setDeliveryEndDate] = useState("");
  const [deliveryProductFilterDropdownOpen, setDeliveryProductFilterDropdownOpen] = useState(false);
  const [deliveryProductSearch, setDeliveryProductSearch] = useState("");
  const [totalItemsDelivered, setTotalItemsDelivered] = useState(0);

  // New state variables for Material Return filters
  const [selectedReturnProduct, setSelectedReturnProduct] = useState("");
  const [returnStartDate, setReturnStartDate] = useState("");
  const [returnEndDate, setReturnEndDate] = useState("");
  const [returnProductFilterDropdownOpen, setReturnProductFilterDropdownOpen] = useState(false);
  const [returnProductSearch, setReturnProductSearch] = useState("");
  const [totalItemsReturned, setTotalItemsReturned] = useState(0);
  const [totalYetToReturn, setTotalYetToReturn] = useState(0);

  // Add these useEffect hooks after your existing useEffects
  useEffect(() => {
    const fetchMaterialDeliveryData = async () => {
      try {
        const company_id = Cookies.get('company_id');
        const response = await api.get(`crudDeliveryStock.php?company_id=${company_id}`);
        if (Array.isArray(response.data)) {
          setMaterialDeliveryData(response.data);
          setFilteredMaterialDeliveryData(response.data);
        }
      } catch (error) {
        console.error("Error fetching material delivery data:", error);
      }
    };

    fetchMaterialDeliveryData();
  }, []);

  useEffect(() => {
    const fetchVendorReturnData = async () => {
      try {
        const company_id = Cookies.get('company_id');
        const response = await api.get(`crudReturnStock.php?company_id=${company_id}`);
        const returns = response.data;
        setVendorReturnData(returns);
        setFilteredVendorReturnData(returns);
      } catch (error) {
        console.error("Error fetching vendor return data:", error);
      }
    };
    fetchVendorReturnData();
  }, []);

  // Add these handlers after your existing handlers
  const handleDeliveryEntriesChange = (value) => {
    setDeliveryEntriesToShow(
      value === "All" ? filteredMaterialDeliveryData.length : Number(value)
    );
    setDeliveryCurrentPage(1);
  };

  const deliveryPrevPage = () => {
    if (deliveryCurrentPage > 1) {
      setDeliveryCurrentPage(deliveryCurrentPage - 1);
    }
  };

  const deliveryNextPage = () => {
    if (
      deliveryCurrentPage <
      Math.ceil(filteredMaterialDeliveryData.length / deliveryEntriesToShow)
    ) {
      setDeliveryCurrentPage(deliveryCurrentPage + 1);
    }
  };

  const handleReturnEntriesChange = (value) => {
    setReturnEntriesToShow(
      value === "All" ? filteredVendorReturnData.length : Number(value)
    );
    setReturnCurrentPage(1);
  };

  const returnNextPage = () => {
    if (
      returnCurrentPage <
      Math.ceil(filteredVendorReturnData.length / returnEntriesToShow)
    ) {
      setReturnCurrentPage(returnCurrentPage + 1);
    }
  };

  const returnPrevPage = () => {
    if (returnCurrentPage > 1) {
      setReturnCurrentPage(returnCurrentPage - 1);
    }
  };

  // Add this useEffect to fetch projects
  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const company_id = Cookies.get('company_id');
        const response = await api.get(`viewProjectDetails.php?company_id=${company_id}`);
        let projectData = [];
        if (Array.isArray(response.data)) {
          projectData = response.data;
        } else if (response.data.projects) {
          projectData = response.data.projects;
        }
        
        // Sort projects by p_id in descending order (newest first)
        const sortedProjects = projectData.sort((a, b) => {
          const idA = parseInt(a.p_id) || 0;
          const idB = parseInt(b.p_id) || 0;
          return idB - idA; // Descending order (newest first)
        });
        
        setProjects(sortedProjects);
      } catch (error) {
        console.error("Error fetching projects:", error);
        setProjects([]);
      }
    };
    fetchProjects();
  }, []);

  // Get unique product names from material delivery data
  const getUniqueDeliveryProducts = () => {
    const uniqueProducts = [...new Set(materialDeliveryData.map(item => item.product_name))];
    return uniqueProducts.filter(product => product); // Remove empty/null values
  };

  // Get unique product names from material return data
  const getUniqueReturnProducts = () => {
    const uniqueProducts = [...new Set(vendorReturnData.map(item => item.product_name))];
    return uniqueProducts.filter(product => product); // Remove empty/null values
  };

  // Initialize total items delivered to 0 when data loads
  useEffect(() => {
    setTotalItemsDelivered(0);
  }, [materialDeliveryData]);

  // Initialize total items returned and yet to return to 0 when data loads
  useEffect(() => {
    setTotalItemsReturned(0);
    setTotalYetToReturn(0);
  }, [vendorReturnData]);

  // Add these filter handlers



  // Add these state declarations after your existing state declarations
  const [returnProductDropdownOpen, setReturnProductDropdownOpen] =
    useState(false);
  const [deliveryModalProjectDropdownOpen, setDeliveryModalProjectDropdownOpen] = useState(false);
  const [deliveryModalProductDropdownOpen, setDeliveryModalProductDropdownOpen] = useState(false);
  const [deliveryModalProductSearch, setDeliveryModalProductSearch] = useState("");

  // Add these toggle functions after your existing handlers
  const toggleDeliveryProjectDropdown = () => {
    setDeliveryProjectDropdownOpen(!deliveryProjectDropdownOpen);
  };

  const toggleReturnProjectDropdown = () => {
    setReturnProjectDropdownOpen(!returnProjectDropdownOpen);
  };

  // Toggle function for delivery product filter dropdown
  const toggleDeliveryProductFilterDropdown = () => {
    setDeliveryProductFilterDropdownOpen(!deliveryProductFilterDropdownOpen);
    // Clear search when closing dropdown
    if (deliveryProductFilterDropdownOpen) {
      setDeliveryProductSearch("");
    }
  };

  // Function to handle delivery product filter
  const handleDeliveryProductFilter = (productName) => {
    setSelectedDeliveryProduct(productName);
    setDeliveryProductSearch(""); // Clear search when selecting a product
    applyDeliveryFilters(selectedDeliveryProject, productName, deliveryStartDate, deliveryEndDate);
  };

  // Function to handle delivery date filters
  const handleDeliveryDateFilter = (startDate, endDate) => {
    setDeliveryStartDate(startDate);
    setDeliveryEndDate(endDate);
    applyDeliveryFilters(selectedDeliveryProject, selectedDeliveryProduct, startDate, endDate);
  };

  // Function to apply all delivery filters
  const applyDeliveryFilters = (projectId, productName, startDate, endDate) => {
    let filtered = materialDeliveryData;

    // Filter by project
    if (projectId) {
      filtered = filtered.filter(item => item.p_id === projectId);
    }

    // Filter by product name
    if (productName) {
      filtered = filtered.filter(item => item.product_name === productName);
    }

    // Filter by date range
    if (startDate || endDate) {
      filtered = filtered.filter(item => {
        const deliveryDate = new Date(item.delivery_date);
        const start = startDate ? new Date(startDate) : new Date('1900-01-01');
        const end = endDate ? new Date(endDate) : new Date('9999-12-31');
        return deliveryDate >= start && deliveryDate <= end;
      });
    }

    setFilteredMaterialDeliveryData(filtered);
    setDeliveryCurrentPage(1);

    // Calculate total items delivered only when specific filters are applied
    // Show total only when product name OR date filters are applied
    if (productName || startDate || endDate) {
      const total = filtered.reduce((sum, item) => sum + parseInt(item.quantity_delivered || 0), 0);
      setTotalItemsDelivered(total);
    } else {
      setTotalItemsDelivered(0);
    }
  };

  // Function to handle delivery project filter
  const handleDeliveryProjectFilter = (projectId) => {
    setSelectedDeliveryProject(projectId);
    applyDeliveryFilters(projectId, selectedDeliveryProduct, deliveryStartDate, deliveryEndDate);
  };

  // Toggle function for return product filter dropdown
  const toggleReturnProductFilterDropdown = () => {
    setReturnProductFilterDropdownOpen(!returnProductFilterDropdownOpen);
    // Clear search when closing dropdown
    if (returnProductFilterDropdownOpen) {
      setReturnProductSearch("");
    }
  };

  // Function to handle return product filter
  const handleReturnProductFilter = (productName) => {
    setSelectedReturnProduct(productName);
    setReturnProductSearch(""); // Clear search when selecting a product
    applyReturnFilters(selectedReturnProject, productName, returnStartDate, returnEndDate);
  };

  // Function to handle return date filters
  const handleReturnDateFilter = (startDate, endDate) => {
    setReturnStartDate(startDate);
    setReturnEndDate(endDate);
    applyReturnFilters(selectedReturnProject, selectedReturnProduct, startDate, endDate);
  };

  // Function to apply all return filters
  const applyReturnFilters = (projectId, productName, startDate, endDate) => {
    let filtered = vendorReturnData;

    // Filter by project
    if (projectId) {
      filtered = filtered.filter(item => item.p_id === projectId);
    }

    // Filter by product name
    if (productName) {
      filtered = filtered.filter(item => item.product_name === productName);
    }

    // Filter by date range
    if (startDate || endDate) {
      filtered = filtered.filter(item => {
        const returnDate = new Date(item.return_date);
        const start = startDate ? new Date(startDate) : new Date('1900-01-01');
        const end = endDate ? new Date(endDate) : new Date('9999-12-31');
        return returnDate >= start && returnDate <= end;
      });
    }

    setFilteredVendorReturnData(filtered);
    setReturnCurrentPage(1);

    // Calculate totals only when specific filters are applied
    if (productName || startDate || endDate) {
      const totalReturned = filtered.reduce((sum, item) => sum + parseInt(item.quantity_returned || 0), 0);
      const totalYetToReturn = filtered.reduce((sum, item) => sum + parseInt(item.yet_to_returned || 0), 0);
      setTotalItemsReturned(totalReturned);
      setTotalYetToReturn(totalYetToReturn);
    } else {
      setTotalItemsReturned(0);
      setTotalYetToReturn(0);
    }
  };

  // Update the existing return project filter to work with new filters
  const handleReturnProjectFilter = (projectId) => {
    setSelectedReturnProject(projectId);
    applyReturnFilters(projectId, selectedReturnProduct, returnStartDate, returnEndDate);
  };



  // Add state for Material Delivery delete confirmation
  const [showDeliveryDeleteConfirmation, setShowDeliveryDeleteConfirmation] = useState(false);
  const [deliveryIdToDelete, setDeliveryIdToDelete] = useState(null);

  // Update the delete handler for Material Delivery
  const handleDeleteDelivery = async () => {
    try {
      const company_id = Cookies.get('company_id');
      const response = await api.delete(`crudDeliveryStock.php`, {
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify({ delivery_id: deliveryIdToDelete, company_id: company_id }),
      });
      if (response.data && response.data.message) {
        setSuccessMessage("Delivery deleted successfully!");
        setShowSuccessAlert(true);
        // Remove the deleted item from the list without reload:
        setFilteredMaterialDeliveryData(prev => prev.filter(item => item.delivery_id !== deliveryIdToDelete));
        setMaterialDeliveryData(prev => prev.filter(item => item.delivery_id !== deliveryIdToDelete));
      } else if (response.data && response.data.error) {
        setAddStockMessage({ type: "danger", text: response.data.error });
      }
    } catch (error) {
      setAddStockMessage({ type: "danger", text: error.response?.data?.error || "Failed to delete delivery." });
    }
    setDeliveryIdToDelete(null);
    setShowDeliveryDeleteConfirmation(false);
  };

  // Add these state declarations for Material Return
  const [materialDeliveryProducts, setMaterialDeliveryProducts] = useState([]);
  const [selectedProductProjects, setSelectedProductProjects] = useState([]);
  const [selectedProjectTracking, setSelectedProjectTracking] = useState([]);

  // Add this useEffect to fetch Material Delivery products
  useEffect(() => {
    const fetchMaterialDeliveryProducts = async () => {
      try {
        const company_id = Cookies.get('company_id');
        const response = await api.get(`crudDeliveryStock.php?company_id=${company_id}`);
        if (Array.isArray(response.data)) {
          setMaterialDeliveryProducts(response.data);
        }
      } catch (error) {
        console.error("Error fetching material delivery products:", error);
      }
    };
    fetchMaterialDeliveryProducts();
  }, []);

  // Add this function to handle product selection
  const handleProductSelect = (productName) => {
    setAddStock3((prev) => ({
      ...prev,
      product_name: productName,
      p_id: "", // Reset project selection
      material_tracking_number: "", // Reset tracking number
      yet_to_returned: "", // Reset yet to returned
    }));

    // Filter projects for selected product
    const projects = materialDeliveryProducts
      .filter((item) => item.product_name === productName)
      .map((item) => ({
        p_id: item.p_id,
        p_name: item.p_name,
      }));
    setSelectedProductProjects(projects);
  };

  // Add these state declarations
  const [selectedDeliveryInfo, setSelectedDeliveryInfo] = useState(null);

  // Update the handleProjectSelect function to include client names
  const handleProjectSelect = (p_id) => {
    setAddStock3((prev) => ({
      ...prev,
      p_id: p_id,
      material_tracking_number: "", // Reset tracking number
      returned_by: "", // Reset returned by
      yet_to_returned: "", // Reset yet to returned
    }));

    // Filter tracking numbers and get delivery info for selected product and project
    const deliveryInfo = materialDeliveryData
      .filter(
        (item) =>
          item.product_name === addstock3.product_name && item.p_id === p_id
      )
      .map((item) => ({
        material_tracking_number: item.material_tracking_number,
        delivered_to_name: item.delivered_to_name,
        quantity_delivered: item.quantity_delivered,
      }));
    setSelectedProjectTracking(deliveryInfo);
  };

  // Add the handleTrackingNumberSelect function
  const handleTrackingNumberSelect = (trackingNumber) => {
    setAddStock3((prev) => ({
      ...prev,
      material_tracking_number: trackingNumber,
    }));

    // Find the delivery info for the selected tracking number
    const deliveryInfo = selectedProjectTracking.find(
      (item) => item.material_tracking_number === trackingNumber
    );
    setSelectedDeliveryInfo(deliveryInfo);
    
    // Calculate remaining quantity based on delivered and previously returned
    if (deliveryInfo) {
      const deliveredQty = parseInt(deliveryInfo.quantity_delivered) || 0;
      
      // Calculate previously returned quantity for this tracking number
      const previouslyReturned = vendorReturnData
        .filter(item => item.material_tracking_number === trackingNumber)
        .reduce((sum, item) => sum + parseInt(item.quantity_returned || 0), 0);
      
      // Calculate remaining quantity to return (this is what can still be returned)
      const remainingQty = Math.max(0, deliveredQty - previouslyReturned);
      
      // Set yet_to_returned to the remaining quantity (this will be updated when quantity_returned changes)
      setAddStock3((prev) => ({
        ...prev,
        yet_to_returned: remainingQty.toString()
      }));
    }
  };

  // Update the Material Tracking Number and Quantity Returned fields in the form
  // This JSX code has been moved to the appropriate location in the return statement

  // Add a function to fetch the latest product data for a given product name
  const fetchLatestProductData = async (productName) => {
    const company_id = Cookies.get('company_id');
    try {
      const response = await api.get(`viewitemsSTM.php?company_id=${company_id}`);
      if (response.data && response.data.products) {
        return response.data.products.find(
          (item) => item.product_name === productName
        );
      }
    } catch (error) {
      console.error('Error fetching latest product data:', error);
    }
    return null;
  };

  // Update the Material Return form JSX
  const handleReturnSubmit = async (event) => {
    event.preventDefault();
    if (
      !addstock3.p_id ||
      !addstock3.product_name ||
      !addstock3.quantity_returned ||
      !addstock3.return_date ||
      !addstock3.returned_by ||
      !addstock3.material_tracking_number
    ) {
      alert('Please fill in all required fields.');
      return;
    }

    // Frontend validation to prevent negative numbers
    if (parseFloat(addstock3.quantity_returned) <= 0) {
      alert('Quantity returned must be greater than 0!');
      return;
    }

    // === FRONTEND VALIDATION ===
    // Find the delivery info for the selected tracking number
    const deliveryInfo = selectedProjectTracking.find(
      (item) => item.material_tracking_number === addstock3.material_tracking_number
    );
    const quantityDelivered = deliveryInfo ? parseInt(deliveryInfo.quantity_delivered) : 0;
    const quantityReturned = parseInt(addstock3.quantity_returned) || 0;
    const yetToReturned = parseInt(addstock3.yet_to_returned) || 0;
    
    // Calculate previously returned quantity for this tracking number
    const previouslyReturned = vendorReturnData
      .filter(item => item.material_tracking_number === addstock3.material_tracking_number)
      .reduce((sum, item) => sum + parseInt(item.quantity_returned || 0), 0);
    
    // Calculate remaining quantity that can still be returned
    const remainingQty = Math.max(0, quantityDelivered - previouslyReturned);
    
    // Validate that returned quantity doesn't exceed remaining quantity
    if (quantityReturned > remainingQty) {
      alert(
        `Returned quantity (${quantityReturned}) cannot exceed remaining quantity (${remainingQty})! Total delivered: ${quantityDelivered}, Previously returned: ${previouslyReturned}`
      );
      return;
    }
    
    // Validate that yet to return is correctly calculated
    const expectedYetToReturn = remainingQty - quantityReturned;
    if (yetToReturned !== expectedYetToReturn) {
      alert(
        `Yet to Return calculation error. Expected: ${expectedYetToReturn}, Got: ${yetToReturned}`
      );
      return;
    }
    // Fetch the latest product data for validation
    const latestProduct = await fetchLatestProductData(addstock3.product_name);
    if (latestProduct) {
      const availableStock = parseInt(latestProduct.available_stock) || 0;
      const totalStock = parseInt(latestProduct.total_stock) || 0;
      if (availableStock + quantityReturned > totalStock) {
        alert(
          `Available stock after return (${availableStock + quantityReturned}) cannot exceed total stock (${totalStock})!`
        );
        return;
      }
    }
    // === END FRONTEND VALIDATION ===

    const company_id = Cookies.get('company_id');
    const formDataToSend = {
      p_id: parseInt(addstock3.p_id),
      product_name: addstock3.product_name.trim(),
      quantity_returned: quantityReturned,
      yet_to_returned: yetToReturned,
      return_date: addstock3.return_date,
      returned_by: addstock3.returned_by,
      material_tracking_number: addstock3.material_tracking_number,
      company_id: company_id,
    };
    try {
      const response = await api.post(`crudReturnStock.php?company_id=${company_id}`, formDataToSend);
      if (response.data && (response.data.status === 'success' || response.data.message)) {
        setSuccessMessage(response.data.message || 'Material returned successfully!');
        setShowSuccessAlert(true);
        setTimeout(() => {
          setShowSuccessAlert(false);
          window.location.reload();
        }, 1500);
      } else if (response.data.error) {
        setAddStockMessage({ type: 'danger', text: response.data.error });
      }
    } catch (error) {
      console.error('Return error:', error);
      setAddStockMessage({ type: 'danger', text: error.response?.data?.error || 'Error submitting return data.' });
    }
  };

  // Add state for Material Return delete confirmation
  const [showReturnDeleteConfirmation, setShowReturnDeleteConfirmation] = useState(false);
  const [returnIdToDelete, setReturnIdToDelete] = useState(null);

  // Add the handleDeleteReturn function
  const handleDeleteReturn = async () => {
    try {
      const company_id = Cookies.get('company_id');
      const response = await api.delete(`crudReturnStock.php`, {
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify({ return_id: returnIdToDelete, company_id: company_id }),
      });
      if (response.data && response.data.message) {
        setSuccessMessage("Return deleted successfully!");
        setShowSuccessAlert(true);
        // Remove the deleted item from the list without reload:
        setFilteredVendorReturnData(prev => prev.filter(item => item.return_id !== returnIdToDelete));
        setVendorReturnData(prev => prev.filter(item => item.return_id !== returnIdToDelete));
      } else if (response.data && response.data.error) {
        setAddStockMessage({ type: "danger", text: response.data.error });
      }
    } catch (error) {
      setAddStockMessage({ type: "danger", text: error.response?.data?.error || "Failed to delete return." });
    }
    setReturnIdToDelete(null);
    setShowReturnDeleteConfirmation(false);
  };

  // Add state for delivery and return search queries
  const [deliverySearchQuery, setDeliverySearchQuery] = useState("");
  const [returnSearchQuery, setReturnSearchQuery] = useState("");

  // Project Report states
  const [projectReports, setProjectReports] = useState([]);
  const [filteredProjectReports, setFilteredProjectReports] = useState([]);
  const [projectReportLoading, setProjectReportLoading] = useState(false);
  const [projectReportGenerating, setProjectReportGenerating] = useState(false);
  const [projectReportMessage, setProjectReportMessage] = useState("");
  const [projectReportMessageType, setProjectReportMessageType] = useState("info");
  const [selectedProjectReportProject, setSelectedProjectReportProject] = useState("");
  const [projectReportProductSearch, setProjectReportProductSearch] = useState("");
  const [projectReportProjectSearch, setProjectReportProjectSearch] = useState("");
  const [projectReportEntriesPerPage, setProjectReportEntriesPerPage] = useState(5);
  const [projectReportCurrentPage, setProjectReportCurrentPage] = useState(1);
  const [projectReportProjectDropdownOpen, setProjectReportProjectDropdownOpen] = useState(false);
  const [projectReportEntriesDropdownOpen, setProjectReportEntriesDropdownOpen] = useState(false);

  // Add state for project search queries in dropdowns
  const [deliveryProjectSearch, setDeliveryProjectSearch] = useState("");
  const [returnProjectSearch, setReturnProjectSearch] = useState("");
  const [deliveryModalProjectSearch, setDeliveryModalProjectSearch] = useState("");
  const [returnModalProjectSearch, setReturnModalProjectSearch] = useState("");
  const [multiDeliveryProjectSearch, setMultiDeliveryProjectSearch] = useState("");
  const [multiReturnProjectSearch, setMultiReturnProjectSearch] = useState("");
  
  // Dropdown open states for Multiple Material Delivery modal
  const [multiDeliveryProjectDropdownOpen, setMultiDeliveryProjectDropdownOpen] = useState(false);

  // Filter logic for Material Delivery List
  useEffect(() => {
    if (deliverySearchQuery === "") {
      setFilteredMaterialDeliveryData(materialDeliveryData);
    } else {
      const trimmedQuery = deliverySearchQuery.trim();
      const filteredResults = materialDeliveryData.filter(
        (item) =>
          (item.product_name && item.product_name.toLowerCase().includes(trimmedQuery.toLowerCase())) ||
          (item.p_name && item.p_name.toLowerCase().includes(trimmedQuery.toLowerCase())) ||
          (item.delivered_to_name && item.delivered_to_name.toLowerCase().includes(trimmedQuery.toLowerCase())) ||
          (item.material_tracking_number && item.material_tracking_number.toLowerCase().includes(trimmedQuery.toLowerCase()))
      );
      setFilteredMaterialDeliveryData(filteredResults);
    }
  }, [deliverySearchQuery, materialDeliveryData]);

  // Filter logic for Material Return List
  useEffect(() => {
    if (returnSearchQuery === "") {
      setFilteredVendorReturnData(vendorReturnData);
    } else {
      const trimmedQuery = returnSearchQuery.trim();
      const filteredResults = vendorReturnData.filter(
        (item) =>
          (item.product_name && item.product_name.toLowerCase().includes(trimmedQuery.toLowerCase())) ||
          (item.p_name && item.p_name.toLowerCase().includes(trimmedQuery.toLowerCase())) ||
          (item.returned_by && item.returned_by.toLowerCase().includes(trimmedQuery.toLowerCase())) ||
          (item.material_tracking_number && item.material_tracking_number.toLowerCase().includes(trimmedQuery.toLowerCase()))
      );
      setFilteredVendorReturnData(filteredResults);
    }
  }, [returnSearchQuery, vendorReturnData]);

  // Apply filters whenever filter states change for Project Report
  useEffect(() => {
    applyProjectReportFilters();
  }, [projectReports, selectedProjectReportProject, projectReportProductSearch]);

  // Auto-load project reports when component mounts
  useEffect(() => {
    loadProjectReports();
  }, []);

  // Calculate paginated data for Project Report
  const projectReportPaginatedData = filteredProjectReports.slice(
    (projectReportCurrentPage - 1) * projectReportEntriesPerPage,
    projectReportCurrentPage * projectReportEntriesPerPage
  );

  const [deliveryType, setDeliveryType] = useState('');
  const [showDeliveryTypeModal, setShowDeliveryTypeModal] = useState(false);

  // Add state for multi delivery modal
  const [showMultiDeliveryModal, setShowMultiDeliveryModal] = useState(false);
  const [multiDelivery, setMultiDelivery] = useState({
    p_id: '',
    delivery_date: '',
    delivered_to: '',
    file: null,
  });
  const [multiDeliveryMessage, setMultiDeliveryMessage] = useState({ type: '', text: '' });
  const [isMultiDeliveryUploading, setIsMultiDeliveryUploading] = useState(false);

  // Add state for Single Return Material modal dropdowns
  const [singleReturnProductDropdownOpen, setSingleReturnProductDropdownOpen] = useState(false);
  const [singleReturnProjectDropdownOpen, setSingleReturnProjectDropdownOpen] = useState(false);
  const [singleReturnProductSearch, setSingleReturnProductSearch] = useState("");
  const [singleReturnProjectSearch, setSingleReturnProjectSearch] = useState("");

  // Add state for Multiple Return Material modal dropdowns
  const [multiReturnProjectDropdownOpen, setMultiReturnProjectDropdownOpen] = useState(false);

  const handleMultiDeliveryChange = (e) => {
    const { name, value, files } = e.target;
    setMultiDelivery(prev => ({
      ...prev,
      [name]: files ? files[0] : value,
    }));
    setMultiDeliveryMessage({ type: '', text: '' }); // Clear previous messages
    
    // Clear project search when project changes
    if (name === 'p_id') {
      setMultiDeliveryProjectSearch("");
    }
  };

  const handleMultiDeliverySubmit = async (e) => {
    e.preventDefault();
    if (!multiDelivery.p_id || !multiDelivery.delivery_date || !multiDelivery.delivered_to || !multiDelivery.file) {
      setMultiDeliveryMessage({ type: 'danger', text: 'Please fill in all required fields.' });
      return;
    }

    setIsMultiDeliveryUploading(true);
    setMultiDeliveryMessage({ type: 'primary', text: 'Uploading and processing file...' });

    const formData = new FormData();
    formData.append('p_id', multiDelivery.p_id);
    formData.append('delivery_date', multiDelivery.delivery_date);
    formData.append('delivered_to', multiDelivery.delivered_to);
    formData.append('excel_file', multiDelivery.file);
    
    const company_id = Cookies.get('company_id');
    formData.append('company_id', company_id);

    try {
      const response = await api.post(`bulkMaterialDeliveryImport.php`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      if (response.data && response.data.status === 'success') {
        // Create detailed message with success/error counts
        const results = response.data.results || {};
        const totalSuccess = results.total_success || 0;
        const totalErrors = results.total_errors || 0;
        const totalProcessed = results.total_processed || 0;
        
        let detailedMessage = response.data.message || 'Material delivery imported successfully!';
        
        if (totalProcessed > 0) {
          detailedMessage += `\n\n📊 Upload Summary:\n`;
          detailedMessage += `✅ Successfully uploaded: ${totalSuccess} records\n`;
          detailedMessage += `❌ Failed: ${totalErrors} records\n`;
          detailedMessage += `📋 Total processed: ${totalProcessed} records`;
          
          // Add error details if there are errors
          if (totalErrors > 0 && results.errors && results.errors.length > 0) {
            detailedMessage += `\n\n❌ Error Details:\n`;
            results.errors.forEach((error, index) => {
              detailedMessage += `${index + 1}. Row ${error.row}: ${error.error}\n`;
            });
          }
        }
        
        setSuccessMessage(detailedMessage);
        setAlertType("success");
        setShowSuccessAlert(true);
        setShowMultiDeliveryModal(false);
        // Clear search field
        setMultiDeliveryProjectSearch("");
        setTimeout(() => {
          setShowSuccessAlert(false);
          window.location.reload();
        }, 2000);
      } else {
        setSuccessMessage(response.data.message || 'Failed to upload file.');
        setAlertType("error");
        setShowSuccessAlert(true);
        setShowMultiDeliveryModal(false);
        // Clear search field
        setMultiDeliveryProjectSearch("");
      }
    } catch (error) {
      console.error('Error uploading file:', error);
      setSuccessMessage(`Error uploading file: ${error.response?.data?.message || error.message}`);
      setAlertType("error");
      setShowSuccessAlert(true);
      setShowMultiDeliveryModal(false);
      // Clear search field
      setMultiDeliveryProjectSearch("");
    } finally {
      setIsMultiDeliveryUploading(false);
    }
  };

  // Add state for Material Delivery dropdown
  const [materialDeliveryDropdownOpen, setMaterialDeliveryDropdownOpen] = useState(false);
  const toggleMaterialDeliveryDropdown = () => setMaterialDeliveryDropdownOpen(prev => !prev);

  // Toggle functions for Single Return Material modal dropdowns
  const toggleSingleReturnProductDropdown = () => {
    setSingleReturnProductDropdownOpen(!singleReturnProductDropdownOpen);
    if (singleReturnProductDropdownOpen) {
      setSingleReturnProductSearch("");
    }
  };

  const toggleSingleReturnProjectDropdown = () => {
    setSingleReturnProjectDropdownOpen(!singleReturnProjectDropdownOpen);
    if (singleReturnProjectDropdownOpen) {
      setSingleReturnProjectSearch("");
    }
  };

  // Toggle function for Multiple Return Material modal dropdown
  const toggleMultiReturnProjectDropdown = () => {
    setMultiReturnProjectDropdownOpen(!multiReturnProjectDropdownOpen);
    if (multiReturnProjectDropdownOpen) {
      setMultiReturnProjectSearch("");
    }
  };

  // 1. Add state for return material dropdown and modal
  const [returnMaterialDropdownOpen, setReturnMaterialDropdownOpen] = useState(false);
  const [showMultiReturnModal, setShowMultiReturnModal] = useState(false);
  const [multiReturn, setMultiReturn] = useState({
    p_id: '',
    returned_by: '',
    return_date: '',
    file: null,
  });
  const [multiReturnMessage, setMultiReturnMessage] = useState({ type: '', text: '' });
  const [isMultiReturnUploading, setIsMultiReturnUploading] = useState(false);
  const [multiReturnClients, setMultiReturnClients] = useState([]);

  // 2. Handle dropdown and modal toggles
  const toggleReturnMaterialDropdown = () => setReturnMaterialDropdownOpen(prev => !prev);
  const handleReturnMaterialOption = (option) => {
    if (option === 'single') {
      toggleRole3(); // existing single return modal
    } else if (option === 'multiple') {
      setShowMultiReturnModal(true);
    }
    setReturnMaterialDropdownOpen(false);
  };

  // 3. Handle project selection for multi return
  const handleMultiReturnProjectChange = (e) => {
    const projectId = e.target.value;
    setMultiReturn(prev => ({ ...prev, p_id: projectId, returned_by: '' }));
    // Find all client names for this project from materialDeliveryData
    const clients = [
      ...new Set(
        materialDeliveryData
          .filter(item => item.p_id === projectId)
          .map(item => item.delivered_to_name)
          .filter(Boolean)
      )
    ];
    setMultiReturnClients(clients);
  };

  // 4. Handle returned by, return date, and file change
  const handleMultiReturnChange = (e) => {
    const { name, value, files } = e.target;
    setMultiReturn(prev => ({
      ...prev,
      [name]: files ? files[0] : value,
    }));
    setMultiReturnMessage({ type: '', text: '' });
  };

  // 5. Handle multi return submit
  const handleMultiReturnSubmit = async (e) => {
    e.preventDefault();
    if (!multiReturn.p_id || !multiReturn.returned_by || !multiReturn.return_date || !multiReturn.file) {
      setMultiReturnMessage({ type: 'danger', text: 'Please fill in all required fields.' });
      return;
    }
    setIsMultiReturnUploading(true);
    setMultiReturnMessage({ type: 'primary', text: 'Uploading and processing file...' });
    const formData = new FormData();
    formData.append('p_id', multiReturn.p_id);
    formData.append('returned_by', multiReturn.returned_by);
    formData.append('return_date', multiReturn.return_date);
    formData.append('excel_file', multiReturn.file);
    const company_id = Cookies.get('company_id');
    formData.append('company_id', company_id);
    try {
      const response = await api.post(`bulkMaterialReturnImport.php`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      
      // Debug: Log the response data
      console.log('Multi Return Submit - Response:', response.data);
      
      if (response.data && response.data.status === 'success') {
        // Create detailed message with success/error counts
        const results = response.data.results || {};
        const totalSuccess = results.total_success || 0;
        const totalErrors = results.total_errors || 0;
        const totalProcessed = results.total_processed || 0;
        
        let detailedMessage = response.data.message || 'Return materials imported successfully!';
        
        if (totalProcessed > 0) {
          detailedMessage += `\n\n📊 Upload Summary:\n`;
          detailedMessage += `✅ Successfully uploaded: ${totalSuccess} records\n`;
          detailedMessage += `❌ Failed: ${totalErrors} records\n`;
          detailedMessage += `📋 Total processed: ${totalProcessed} records`;
          
          // Add error details if there are errors
          if (totalErrors > 0 && results.errors && results.errors.length > 0) {
            detailedMessage += `\n\n❌ Error Details:\n`;
            results.errors.forEach((error, index) => {
              detailedMessage += `${index + 1}. Row ${error.row}: ${error.error}\n`;
            });
          }
        }
        
        setSuccessMessage(detailedMessage);
        setAlertType("success");
        setShowSuccessAlert(true);
        setShowMultiReturnModal(false);
        setTimeout(() => {
          setShowSuccessAlert(false);
          window.location.reload();
        }, 2000);
      } else {
        setSuccessMessage(response.data.message || 'Failed to upload file.');
        setAlertType("error");
        setShowSuccessAlert(true);
        setShowMultiReturnModal(false);
      }
    } catch (error) {
      console.error('Multi Return Submit - Error:', error);
      setSuccessMessage(`Error uploading file: ${error.response?.data?.message || error.message}`);
      setAlertType("error");
      setShowSuccessAlert(true);
      setShowMultiReturnModal(false);
    } finally {
      setIsMultiReturnUploading(false);
    }
  };

  // 6. Add the dropdown and modal in the return section UI
  // ... inside the return section's button row ...
  <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
    <Button
      style={{ backgroundColor: "#d86f89", borderColor: "#d86f89", color: "black" }}
      onClick={toggleReturnMaterialDropdown}
    >
      Add Return Materials <i className="fas fa-chevron-down ml-2"></i>
    </Button>
    <Dropdown isOpen={returnMaterialDropdownOpen} toggle={toggleReturnMaterialDropdown} direction="down">
      <DropdownMenu>
        <DropdownItem onClick={() => handleReturnMaterialOption('single')}>
          Add Single Return Material
        </DropdownItem>
        <DropdownItem onClick={() => handleReturnMaterialOption('multiple')}>
          Add Multiple Return Materials
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  </div>
  // Place the <Modal isOpen={showMultiReturnModal} ... /> at the root of the return section (not inside any other element), so it is a sibling to other modals and not inside the render return directly.

  // Add these two functions at the top-level of the component (after other functions)
  const handleDownloadDelivery = () => {
    if (!Array.isArray(filteredMaterialDeliveryData) || filteredMaterialDeliveryData.length === 0) {
      alert("No data available to download");
      return;
    }
    const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";
    const fileName = "material_delivery_list";
    const formattedData = filteredMaterialDeliveryData.map((item, idx) => ({
      "S.No": idx + 1,
      "Project Name": item.p_name,
      "Product Name": item.product_name,
      "Quantity Delivered": item.quantity_delivered,
      "Delivered Date": item.delivery_date,
      "Delivered To": item.delivered_to_name,
      "Cost": item.product_cost,
      "Material Tracking Number": item.material_tracking_number,
    }));
    const ws = XLSX.utils.json_to_sheet(formattedData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Material Delivery List");
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const excelData = new Blob([excelBuffer], { type: fileType });
    const excelUrl = URL.createObjectURL(excelData);
    const link = document.createElement("a");
    link.href = excelUrl;
    link.download = fileName + fileExtension;
    document.body.appendChild(link);
    link.click();
    setTimeout(() => {
      document.body.removeChild(link);
      window.URL.revokeObjectURL(excelUrl);
    }, 100);
  };

  const handleDownloadReturn = () => {
    if (!Array.isArray(filteredVendorReturnData) || filteredVendorReturnData.length === 0) {
      alert("No data available to download");
      return;
    }
    const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";
    const fileName = "material_return_list";
    const formattedData = filteredVendorReturnData.map((item, idx) => ({
      "S.No": idx + 1,
      "Project Name": item.p_name,
      "Product Name": item.product_name,
      "Quantity Returned": item.quantity_returned,
      "Yet To Return": item.yet_to_returned,
      "Return Date": item.return_date,
      "Returned By": item.returned_by,
      "Material Tracking Number": item.material_tracking_number,
    }));
    const ws = XLSX.utils.json_to_sheet(formattedData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Material Return List");
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const excelData = new Blob([excelBuffer], { type: fileType });
    const excelUrl = URL.createObjectURL(excelData);
    const link = document.createElement("a");
    link.href = excelUrl;
    link.download = fileName + fileExtension;
    document.body.appendChild(link);
    link.click();
    setTimeout(() => {
      document.body.removeChild(link);
      window.URL.revokeObjectURL(excelUrl);
    }, 100);
  };

  // Project Report functions
  const loadProjectReports = async () => {
    try {
      setProjectReportLoading(true);
      const params = { company_id: Cookies.get('company_id') };
      
      const response = await api.get('/storeProjectReport.php', { params });
      
      if (response.data.status === 'success') {
        console.log('📊 Project Reports loaded:', response.data.reports);
        setProjectReports(response.data.reports || []);
        setProjectReportMessage('');
      } else {
        setProjectReportMessage(response.data.message || 'Error loading reports');
        setProjectReportMessageType('danger');
      }
    } catch (error) {
      console.error('Error loading project reports:', error);
      setProjectReportMessage('Error loading project reports');
      setProjectReportMessageType('danger');
    } finally {
      setProjectReportLoading(false);
    }
  };

  const generateProjectReport = async () => {
    try {
      setProjectReportGenerating(true);
      setProjectReportMessage('Generating report...');
      setProjectReportMessageType('info');
      
      const company_id = Cookies.get('company_id');
      const formData = {
        company_id: company_id,
        action: 'generate'
      };
      
      const response = await api.post('/storeProjectReport.php', formData);
      
      if (response.data.status === 'success') {
        setProjectReportMessage(`Report generated successfully! ${response.data.records_created} records created.`);
        setProjectReportMessageType('success');
        // Reload the reports after generation
        await loadProjectReports();
      } else {
        setProjectReportMessage(response.data.message || 'Error generating report');
        setProjectReportMessageType('danger');
      }
    } catch (error) {
      console.error('Error generating project report:', error);
      setProjectReportMessage('Error generating project report');
      setProjectReportMessageType('danger');
    }
    setProjectReportGenerating(false);
  };

  const applyProjectReportFilters = () => {
    let filtered = [...projectReports];

    console.log('🔍 Project Report Filter Debug:');
    console.log('Total reports:', projectReports.length);
    console.log('Selected project:', selectedProjectReportProject);
    console.log('Product search:', projectReportProductSearch);

    if (selectedProjectReportProject) {
      filtered = filtered.filter(report => String(report.p_id) === String(selectedProjectReportProject));
      console.log('After project filter:', filtered.length);
    }

    if (projectReportProductSearch) {
      filtered = filtered.filter(report => 
        report.product_name.toLowerCase().includes(projectReportProductSearch.toLowerCase())
      );
      console.log('After product search filter:', filtered.length);
    }

    console.log('Final filtered results:', filtered.length);
    setFilteredProjectReports(filtered);
    setProjectReportCurrentPage(1);
  };

  const clearProjectReportFilters = () => {
    setSelectedProjectReportProject('');
    setProjectReportProductSearch('');
    setProjectReportProjectSearch('');
  };

  const exportProjectReportToCSV = () => {
    const csvContent = [
      ['Project Name', 'Product Name', 'Delivered Quantity', 'Returned Quantity', 'Yet To Return'],
      ...filteredProjectReports.map(report => [
        report.project_name,
        report.product_name,
        report.delivered_quantity,
        report.returned_quantity,
        report.yet_to_return
      ])
    ].map(row => row.join(',')).join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', 'project_report.csv');
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleProjectReportEntriesChange = (value) => {
    setProjectReportEntriesPerPage(value === "All" ? filteredProjectReports.length : Number(value));
    setProjectReportCurrentPage(1);
  };

  const projectReportPrevPage = () => {
    if (projectReportCurrentPage > 1) {
      setProjectReportCurrentPage(projectReportCurrentPage - 1);
    }
  };

  const projectReportNextPage = () => {
    const totalPages = Math.ceil(filteredProjectReports.length / projectReportEntriesPerPage);
    if (projectReportCurrentPage < totalPages) {
      setProjectReportCurrentPage(projectReportCurrentPage + 1);
    }
  };

  return (
    <>
      <div className="header py-7 py-lg-8" style={{ background: 'transparent' }}>
        <Container fluid>
          
          {/* <h1 className="text-white text-center mb-4">Stock Management</h1> */}

          <Row className="">
            <Col xl="12" style={{ marginTop: "-20px" }}>
              <Card
                className=""
                style={{
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                  backgroundColor: "#fff",
                  borderRadius: "15px",
                }}
              >
                <CardBody>
                  <CardHeader className="border-0">
                    <Row className="align-items-center">
                      <div className="col-12 d-flex justify-content-between align-items-center">
                        <h3 className="mb-0">In-House Stock List</h3>
                        <div className="d-flex align-items-center" style={{ flexWrap: 'nowrap', gap: '8px' }}>
                          {/* Search Input */}
                          <InputGroup className="input-group-alternative" style={{ maxWidth: 180 }}>
                            <InputGroupAddon addonType="prepend">
                              <InputGroupText>
                                <i className="fas fa-search" style={{ color: "#d86f89" }} />
                              </InputGroupText>
                            </InputGroupAddon>
                            <Input
                              placeholder="Search Stock"
                              type="text"
                              value={searchQuery}
                              onChange={(e) => setSearchQuery(e.target.value)}
                            />
                          </InputGroup>

                          {/* Show Entries Dropdown */}
                          <Dropdown isOpen={projectDropdownOpen} toggle={toggleProjectDropdown}>
                            <DropdownToggle caret>
                              Show Entries:{" "}
                              {entriesToShow === filteredData.length ? "All" : entriesToShow}
                            </DropdownToggle>
                            <DropdownMenu>
                              <DropdownItem onClick={() => handleEntriesChange(5)}>5</DropdownItem>
                              <DropdownItem onClick={() => handleEntriesChange(10)}>10</DropdownItem>
                              <DropdownItem onClick={() => handleEntriesChange(50)}>50</DropdownItem>
                              <DropdownItem onClick={() => handleEntriesChange("All")}>All</DropdownItem>
                            </DropdownMenu>
                          </Dropdown>

                          {/* Download Button */}
                          <Button 
                            className="btn btn-success" 
                            onClick={handleDownload}
                            style={{
                              backgroundColor: "#d86f89",
                              borderColor: "#d86f89",
                              color: "black",
                            }}
                          >
                            Download
                          </Button>

                          {/* Add Stock Dropdown */}
                          <Dropdown isOpen={addStockDropdownOpen} toggle={toggleAddStockDropdown}>
                            <DropdownToggle
                              style={{
                                backgroundColor: '#d86f89',
                                borderColor: '#d86f89',
                                color: 'black',
                                fontWeight: 600,
                                borderRadius: '0.375rem',
                                boxShadow: 'none',
                                padding: '0.5rem 1.25rem',
                              }}
                            >
                              Add Stock <i className="fas fa-chevron-down ml-1"></i>
                            </DropdownToggle>
                            <DropdownMenu>
                              <DropdownItem onClick={() => handleAddStockOption('single')}>
                                <i className="fas fa-plus mr-2"></i>
                                Add Single Material
                              </DropdownItem>
                              <DropdownItem onClick={() => handleAddStockOption('multiple')}>
                                <i className="fas fa-upload mr-2"></i>
                                Add Multiple Materials
                              </DropdownItem>
                            </DropdownMenu>
                          </Dropdown>
                        </div>
                      </div>
                    </Row>

                  </CardHeader>
                  <Table className="align-items-center table-flush" responsive>
                    <thead className="thead-light">
                      <tr>
                        <th scope="col">Item Id</th>
                        <th scope="col">Product Name</th>
                        <th scope="col">Current Stock(Quantity)</th>
                        <th scope="col">Total Stock</th>
                        {/* <th scope="col">Unit(Kg)</th> */}
                        <th scope="col">Cost</th>
                        {/* <th scope="col">Material Tracking Number</th> */}
                        {/* <th scope="col">Action</th> */}
                      </tr>
                    </thead>
                    <tbody style={{ textAlign: "center" }}>
                      {dataToShow.length === 0 ? (
                        <tr>
                          <td colSpan="6" style={{ color: '#888', fontWeight: 'bold' }}>
                            Material not found
                          </td>
                        </tr>
                      ) : (
                        dataToShow.map((item, index) => (
                          <tr key={index}>
                            <th scope="row">{index + 1}</th>
                            <td>{item.product_name}</td>
                            <td>{item.available_stock}</td>
                            <td>{item.total_stock}</td>
                            <td>{item.cost}</td>
                            {/* <td>{item.material_tracking_number}</td> */}
                            <td
                              style={{
                                display: "flex",
                                justifyContent: "space-evenly",
                              }}
                            >
                              {/* <Link
                                to={`/store-admin/store-management/editstock4/${item.product_id}`}
                                style={{ marginRight: "10px" }}
                              >
                                <Tippy content="Edit">
                                  <i
                                    className="fa-solid fa-pen"
                                    style={{
                                      fontSize: "23px",
                                      color: "green",
                                      cursor: "pointer",
                                    }}
                                  ></i>
                                </Tippy>
                              </Link> */}
                              {/* <Tippy content="Delete">
                                <i
                                  className="fa fa-trash"
                                  style={{
                                    fontSize: "23px",
                                    color: "red",
                                    cursor: "pointer",
                                  }}
                                  onClick={() =>
                                    handleDeleteIconClick(item.product_id)
                                  }
                                ></i>
                              </Tippy> */}
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </Table>
                  {/* Entries Info */}
                  <div className="d-flex justify-content-between align-items-center mt-3">
                    <div className="text-muted">
                      Showing {((currentPage - 1) * entriesToShow) + 1} to {Math.min(currentPage * entriesToShow, filteredData.length)} of {filteredData.length} entries
                    </div>
                  </div>

                  <nav className="mt-3">
                    <ul className="pagination justify-content-center">
                      <li className="page-item">
                        <a
                          href="#"
                          className="page-link"
                          style={{ color: "#d86f89" }}
                          onClick={prePage}
                          disabled={currentPage === 1}
                        >
                          Prev
                        </a>
                      </li>
                      <li className="page-item">
                        <a
                          href="#"
                          className="page-link"
                          style={{ color: "#d86f89" }}
                          onClick={nextPage}
                          disabled={currentPage === totalPages}
                        >
                          Next
                        </a>
                      </li>
                    </ul>
                  </nav>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row className="mt-4">
  <Col xl="12">

    <Card style={{
      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
      backgroundColor: "#fff",
      borderRadius: "15px",
    }}>
      <CardBody>
        <CardHeader className="border-0">
          <Row className="align-items-center">
            <div className="col-12 d-flex justify-content-between align-items-center">
              <h3 className="mb-0">Material Delivery List</h3>
              <div className="d-flex align-items-center" style={{ flexWrap: 'nowrap', gap: '8px' }}>
              {/* Project Dropdown */}
              <Dropdown isOpen={deliveryProjectDropdownOpen} toggle={toggleDeliveryProjectDropdown}>
                <DropdownToggle caret>
                  {selectedDeliveryProject
                    ? projects.find((p) => p.p_id === selectedDeliveryProject)?.p_name
                    : "Select Project"}
                </DropdownToggle>
                <DropdownMenu style={{ width: '300px', padding: '8px', maxHeight: '250px', overflowY: 'auto' }}>
                  {/* Search Bar */}
                  <div className="mb-2">
                    <Input
                      type="text"
                      placeholder="Search projects..."
                      value={deliveryProjectSearch || ''}
                      onChange={(e) => setDeliveryProjectSearch(e.target.value)}
                      style={{ fontSize: '13px', height: '32px' }}
                    />
                  </div>
                  <DropdownItem onClick={() => handleDeliveryProjectFilter("")} style={{ padding: '6px 12px', fontSize: '13px' }}>All Projects</DropdownItem>
                  {projects
                    .filter(project => 
                      !deliveryProjectSearch || 
                      project.p_name.toLowerCase().includes(deliveryProjectSearch.toLowerCase())
                    )
                    .map((project) => (
                      <DropdownItem key={project.p_id} onClick={() => handleDeliveryProjectFilter(project.p_id)} style={{ padding: '6px 12px', fontSize: '13px' }}>
                      {project.p_name}
                    </DropdownItem>
                  ))}
                </DropdownMenu>
              </Dropdown>
              {/* Search */}
              {/* <InputGroup className="input-group-alternative" style={{ maxWidth: 180 }}>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>
                    <i className="fas fa-search" style={{ color: "#222", fontSize: "1rem" }} />
                  </InputGroupText>
                </InputGroupAddon>
                <Input
                  placeholder="Search Product Name"
                  type="text"
                  value={deliverySearchQuery}
                  onChange={e => setDeliverySearchQuery(e.target.value)}
                  style={{ fontSize: "1rem" }}
                />
              </InputGroup> */}

              {/* Show Entries */}
              <Dropdown isOpen={deliveryShowEntriesDropdownOpen} toggle={() => setDeliveryShowEntriesDropdownOpen((prev) => !prev)}>
                <DropdownToggle caret>
                  Show Entries: {deliveryEntriesToShow === filteredMaterialDeliveryData.length ? "All" : deliveryEntriesToShow}
                </DropdownToggle>
                <DropdownMenu>
                  <DropdownItem onClick={() => handleDeliveryEntriesChange(5)}>5</DropdownItem>
                  <DropdownItem onClick={() => handleDeliveryEntriesChange(10)}>10</DropdownItem>
                  <DropdownItem onClick={() => handleDeliveryEntriesChange(50)}>50</DropdownItem>
                  <DropdownItem onClick={() => handleDeliveryEntriesChange("All")}>All</DropdownItem>
                </DropdownMenu>
              </Dropdown>
                                           {/* Download */}
              <Button
                className="btn btn-success"
                onClick={handleDownloadDelivery}
                style={{ backgroundColor: "#d86f89", borderColor: "#d86f89", color: "black" }}
              >
                Download
              </Button>
              {/* Add Material Delivery */}
              <Dropdown isOpen={materialDeliveryDropdownOpen} toggle={toggleMaterialDeliveryDropdown}>
                 <DropdownToggle
                   style={{
                     backgroundColor: "#d86f89",
                     borderColor: "#d86f89",
                     color: "black",
                     fontWeight: 600,
                     borderRadius: '0.375rem',
                     boxShadow: 'none',
                     padding: '0.5rem 1.25rem',
                     display: 'flex',
                     alignItems: 'center',
                     gap: '0.5em'
                   }}
                 >
                   Material Delivery <i className="fas fa-chevron-down ml-2"></i>
                 </DropdownToggle>
                 <DropdownMenu>
                   <DropdownItem onClick={() => setShowRoleModal2(true)}>
                     Add Single Material Delivery
                   </DropdownItem>
                                           <DropdownItem onClick={() => {
                          setShowMultiDeliveryModal(true);
                          // Clear search field when opening modal
                          setMultiDeliveryProjectSearch("");
                        }}>
                          Add Multiple Material Delivery
                        </DropdownItem>
                 </DropdownMenu>
               </Dropdown>
              </div>
            </div>
          </Row>
        </CardHeader>

        {/* Filters Section */}
        <div className="mb-3 p-3" style={{ backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
          <Row className="align-items-center">
            <Col md="3">
              <Label className="form-control-label">Product Name Filter:</Label>
              <Dropdown isOpen={deliveryProductFilterDropdownOpen} toggle={toggleDeliveryProductFilterDropdown}>
                <DropdownToggle caret style={{ width: '100%', textAlign: 'left' }}>
                  {selectedDeliveryProduct || "Select Product"}
                </DropdownToggle>
                <DropdownMenu style={{ width: '100%', padding: '8px', maxHeight: '250px', overflowY: 'auto' }}>
                  {/* Search Bar */}
                  <div className="mb-2">
                    <Input
                      type="text"
                      placeholder="Search products..."
                      value={deliveryProductSearch || ''}
                      onChange={(e) => setDeliveryProductSearch(e.target.value)}
                      style={{ fontSize: '13px', height: '32px' }}
                    />
                  </div>
                  <DropdownItem onClick={() => handleDeliveryProductFilter("")} style={{ padding: '6px 12px', fontSize: '13px' }}>
                    All Products
                  </DropdownItem>
                  {getUniqueDeliveryProducts()
                    .filter(product => 
                      !deliveryProductSearch || 
                      product.toLowerCase().includes(deliveryProductSearch.toLowerCase())
                    )
                    .map((product) => (
                      <DropdownItem 
                        key={product} 
                        onClick={() => handleDeliveryProductFilter(product)}
                        style={{ padding: '6px 12px', fontSize: '13px' }}
                      >
                        {product}
                      </DropdownItem>
                    ))}
                </DropdownMenu>
              </Dropdown>
            </Col>
            <Col md="3">
              <Label className="form-control-label">Start Date:</Label>
              <Input
                type="date"
                value={deliveryStartDate}
                onChange={(e) => handleDeliveryDateFilter(e.target.value, deliveryEndDate)}
                style={{ width: '100%' }}
              />
            </Col>
            <Col md="3">
              <Label className="form-control-label">End Date:</Label>
              <Input
                type="date"
                value={deliveryEndDate}
                onChange={(e) => handleDeliveryDateFilter(deliveryStartDate, e.target.value)}
                style={{ width: '100%' }}
              />
            </Col>
            <Col md="3">
              <Label className="form-control-label">Total Items Delivered:</Label>
              <div className="form-control" style={{ 
                backgroundColor: '#e9ecef', 
                border: '1px solid #ced4da',
                padding: '0.375rem 0.75rem',
                borderRadius: '0.375rem',
                fontWeight: 'bold',
                color: '#495057'
              }}>
                {totalItemsDelivered}
              </div>
            </Col>
          </Row>
        </div>

        <Table className="align-items-center table-flush" responsive>
          <thead className="thead-light">
            <tr>
              <th scope="col">Item Id</th>
              <th scope="col">Project Name</th>
              <th scope="col">Product Name</th>
              <th scope="col">Quantity Delivered</th>
              <th scope="col">Delivered Date</th>
              <th scope="col">Delivered To</th>
              <th scope="col">Cost</th>
              <th scope="col">Material Tracking Number</th>
              <th scope="col">Action</th>
            </tr>
          </thead>
          <tbody style={{ textAlign: "center" }}>
            {filteredMaterialDeliveryData.length === 0 ? (
              <tr>
                <td colSpan="9" style={{ color: '#888', fontWeight: 'bold' }}>
                  No such material delivered
                </td>
              </tr>
            ) : (
              filteredMaterialDeliveryData
                .slice(
                  (deliveryCurrentPage - 1) * deliveryEntriesToShow,
                  deliveryCurrentPage * deliveryEntriesToShow
                )
                .map((item, index) => (
                  <tr key={item.delivery_id || index}>
                    <th scope="row">
                      {(deliveryCurrentPage - 1) * deliveryEntriesToShow + index + 1}
                    </th>
                    <td>{item.p_name}</td>
                    <td>{item.product_name}</td>
                    <td>{item.quantity_delivered}</td>
                    <td>{item.delivery_date}</td>
                    <td>{item.delivered_to_name}</td>
                    <td>{item.product_cost}</td>
                    <td>{item.material_tracking_number}</td>
                    <td>
                      <Tippy content="Delete">
                        <i
                          className="fa fa-trash"
                          style={{
                            fontSize: "23px",
                            color: "red",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            setDeliveryIdToDelete(item.delivery_id);
                            setShowDeliveryDeleteConfirmation(true);
                          }}
                        ></i>
                      </Tippy>
                    </td>
                  </tr>
                ))
            )}
          </tbody>
        </Table>

        {/* Entries Info */}
        <div className="d-flex justify-content-between align-items-center mt-3">
          <div className="text-muted">
            Showing {((deliveryCurrentPage - 1) * deliveryEntriesToShow) + 1} to {Math.min(deliveryCurrentPage * deliveryEntriesToShow, filteredMaterialDeliveryData.length)} of {filteredMaterialDeliveryData.length} entries
          </div>
        </div>

        <nav className="mt-3">
          <ul className="pagination justify-content-center">
            <li className="page-item">
              <a
                href="#"
                className="page-link"
                style={{ color: "#d86f89" }}
                onClick={deliveryPrevPage}
                disabled={deliveryCurrentPage === 1}
              >
                Prev
              </a>
            </li>
            <li className="page-item">
              <a
                href="#"
                className="page-link"
                style={{ color: "#d86f89" }}
                onClick={deliveryNextPage}
                disabled={
                  deliveryCurrentPage ===
                  Math.ceil(filteredMaterialDeliveryData.length / deliveryEntriesToShow)
                }
              >
                Next
              </a>
            </li>
          </ul>
        </nav>
      </CardBody>
    </Card>
  </Col>
</Row>


          <Row className="mt-4">
  <Col xl="12">

    {/* Card & Table section */}
    <Card
      style={{
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
        backgroundColor: "#fff",
        borderRadius: "15px",
      }}
    >
      <CardBody>
        <CardHeader className="border-0">
          <Row className="align-items-center">
            <div className="col-12 d-flex justify-content-between align-items-center">
              <h3 className="mb-0">Material Return List</h3>
              <div className="d-flex align-items-center" style={{ flexWrap: 'nowrap', gap: '8px' }}>
              {/* Project Dropdown */}
              <Dropdown isOpen={returnProjectDropdownOpen} toggle={toggleReturnProjectDropdown}>
                <DropdownToggle caret>
                  {selectedReturnProject
                    ? projects.find((p) => p.p_id === selectedReturnProject)?.p_name
                    : "Select Project"}
                </DropdownToggle>
                <DropdownMenu style={{ width: '300px', padding: '8px', maxHeight: '250px', overflowY: 'auto' }}>
                  {/* Search Bar */}
                  <div className="mb-2">
                    <Input
                      type="text"
                      placeholder="Search projects..."
                      value={returnProjectSearch || ''}
                      onChange={(e) => setReturnProjectSearch(e.target.value)}
                      style={{ fontSize: '13px', height: '32px' }}
                    />
                  </div>
                  <DropdownItem onClick={() => handleReturnProjectFilter("")} style={{ padding: '6px 12px', fontSize: '13px' }}>All Projects</DropdownItem>
                  {projects
                    .filter(project => 
                      !returnProjectSearch || 
                      project.p_name.toLowerCase().includes(returnProjectSearch.toLowerCase())
                    )
                    .map((project) => (
                      <DropdownItem key={project.p_id} onClick={() => handleReturnProjectFilter(project.p_id)} style={{ padding: '6px 12px', fontSize: '13px' }}>
                      {project.p_name}
                    </DropdownItem>
                  ))}
                </DropdownMenu>
              </Dropdown>
              {/* Search */}
              {/* <InputGroup className="input-group-alternative" style={{ maxWidth: 180 }}>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>
                    <i className="fas fa-search" style={{ color: "#222", fontSize: "1rem" }} />
                  </InputGroupText>
                </InputGroupAddon>
                <Input
                  placeholder="Search Product Name"
                  type="text"
                  value={returnSearchQuery}
                  onChange={e => setReturnSearchQuery(e.target.value)}
                  style={{ fontSize: "1rem" }}
                />
              </InputGroup> */}

              {/* Show Entries */}
              <Dropdown isOpen={returnShowEntriesDropdownOpen} toggle={() => setReturnShowEntriesDropdownOpen((prev) => !prev)}>
                <DropdownToggle caret>
                  Show Entries: {returnEntriesToShow === filteredVendorReturnData.length ? "All" : returnEntriesToShow}
                </DropdownToggle>
                <DropdownMenu>
                  <DropdownItem onClick={() => handleReturnEntriesChange(5)}>5</DropdownItem>
                  <DropdownItem onClick={() => handleReturnEntriesChange(10)}>10</DropdownItem>
                  <DropdownItem onClick={() => handleReturnEntriesChange(50)}>50</DropdownItem>
                  <DropdownItem onClick={() => handleReturnEntriesChange("All")}>All</DropdownItem>
                </DropdownMenu>
              </Dropdown>
                                           {/* Download */}
              <Button
                className="btn btn-success"
                onClick={handleDownloadReturn}
                style={{ backgroundColor: "#d86f89", borderColor: "#d86f89", color: "black" }}
              >
                Download
              </Button>
              {/* Add Return Materials */}
              <Dropdown isOpen={returnMaterialDropdownOpen} toggle={toggleReturnMaterialDropdown}>
                 <DropdownToggle
                   style={{
                     backgroundColor: "#d86f89",
                     borderColor: "#d86f89",
                     color: "black",
                     fontWeight: 600,
                     borderRadius: '0.375rem',
                     boxShadow: 'none',
                     padding: '0.5rem 1.25rem',
                     display: 'flex',
                     alignItems: 'center',
                     gap: '0.5em'
                   }}
                   caret
                 >
                   Add Return Materials
                 </DropdownToggle>
                 <DropdownMenu>
                   <DropdownItem onClick={() => handleReturnMaterialOption('single')}>
                     Add Single Return Material
                   </DropdownItem>
                   <DropdownItem onClick={() => handleReturnMaterialOption('multiple')}>
                     Add Multiple Return Materials
                   </DropdownItem>
                 </DropdownMenu>
               </Dropdown>
              </div>
            </div>
          </Row>
        </CardHeader>

        {/* Filters Section for Material Return */}
        <div className="mb-3 p-3" style={{ backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
          <Row className="align-items-center">
            <Col md="3">
              <Label className="form-control-label">Product Name Filter:</Label>
              <Dropdown isOpen={returnProductFilterDropdownOpen} toggle={toggleReturnProductFilterDropdown}>
                <DropdownToggle caret style={{ width: '100%', textAlign: 'left' }}>
                  {selectedReturnProduct || "Select Product"}
                </DropdownToggle>
                <DropdownMenu style={{ width: '100%', padding: '8px', maxHeight: '250px', overflowY: 'auto' }}>
                  {/* Search Bar */}
                  <div className="mb-2">
                    <Input
                      type="text"
                      placeholder="Search products..."
                      value={returnProductSearch || ''}
                      onChange={(e) => setReturnProductSearch(e.target.value)}
                      style={{ fontSize: '13px', height: '32px' }}
                    />
                  </div>
                  <DropdownItem onClick={() => handleReturnProductFilter("")} style={{ padding: '6px 12px', fontSize: '13px' }}>
                    All Products
                  </DropdownItem>
                  {getUniqueReturnProducts()
                    .filter(product => 
                      !returnProductSearch || 
                      product.toLowerCase().includes(returnProductSearch.toLowerCase())
                    )
                    .map((product) => (
                      <DropdownItem 
                        key={product} 
                        onClick={() => handleReturnProductFilter(product)}
                        style={{ padding: '6px 12px', fontSize: '13px' }}
                      >
                        {product}
                      </DropdownItem>
                    ))}
                </DropdownMenu>
              </Dropdown>
            </Col>
            <Col md="2">
              <Label className="form-control-label">Start Date:</Label>
              <Input
                type="date"
                value={returnStartDate}
                onChange={(e) => handleReturnDateFilter(e.target.value, returnEndDate)}
                style={{ width: '100%' }}
              />
            </Col>
            <Col md="2">
              <Label className="form-control-label">End Date:</Label>
              <Input
                type="date"
                value={returnEndDate}
                onChange={(e) => handleReturnDateFilter(returnStartDate, e.target.value)}
                style={{ width: '100%' }}
              />
            </Col>
            <Col md="2">
              <Label className="form-control-label">Total Items Returned:</Label>
              <div className="form-control" style={{ 
                backgroundColor: '#e9ecef', 
                border: '1px solid #ced4da',
                padding: '0.375rem 0.75rem',
                borderRadius: '0.375rem',
                fontWeight: 'bold',
                color: '#495057'
              }}>
                {totalItemsReturned}
              </div>
            </Col>
            <Col md="3">
              <Label className="form-control-label">Total Yet to Return:</Label>
              <div className="form-control" style={{ 
                backgroundColor: '#e9ecef', 
                border: '1px solid #ced4da',
                padding: '0.375rem 0.75rem',
                borderRadius: '0.375rem',
                fontWeight: 'bold',
                color: '#495057'
              }}>
                {totalYetToReturn}
              </div>
            </Col>
          </Row>
        </div>

        <Table className="align-items-center table-flush" responsive>
          <thead className="thead-light">
            <tr>
              <th scope="col">Item Id</th>
              <th scope="col">Project Name</th>
              <th scope="col">Product Name</th>
              <th scope="col">Quantity Returned</th>
              <th scope="col">Yet To Return</th>
              <th scope="col">Return Date</th>
              <th scope="col">Returned By</th>
              <th scope="col">Material Tracking Number</th>
              <th scope="col">Action</th>
            </tr>
          </thead>
          <tbody style={{ textAlign: "center" }}>
            {filteredVendorReturnData.length === 0 ? (
              <tr>
                <td colSpan="9" style={{ color: '#888', fontWeight: 'bold' }}>
                  No such material returned
                </td>
              </tr>
            ) : (
              filteredVendorReturnData
                .slice(
                  (returnCurrentPage - 1) * returnEntriesToShow,
                  returnCurrentPage * returnEntriesToShow
                )
                .map((item, index) => (
                  <tr key={item.return_id || index}>
                    <th scope="row">
                      {(returnCurrentPage - 1) * returnEntriesToShow + index + 1}
                    </th>
                    <td>{item.p_name}</td>
                    <td>{item.product_name}</td>
                    <td>{item.quantity_returned}</td>
                    <td>{item.yet_to_returned}</td>
                    <td>{item.return_date}</td>
                    <td>{item.returned_by}</td>
                    <td>{item.material_tracking_number}</td>
                    <td>
                      <Link
                        to={`/store-admin/store-management/editMaterialReturn/${item.return_id}`}
                        style={{ marginRight: "10px" }}
                      >
                        <Tippy content="Edit Return Stock">
                        <i
                          className="fa-solid fa-pen"
                          style={{
                            fontSize: "23px",
                            color: "green",
                            cursor: "pointer",
                          }}
                        ></i>
                        </Tippy>
                      </Link>
                      <Tippy content="Delete">
                      <i
                        className="fa fa-trash"
                        style={{
                          fontSize: "23px",
                          color: "red",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          setReturnIdToDelete(item.return_id);
                          setShowReturnDeleteConfirmation(true);
                        }}
                      ></i></Tippy>
                    </td>
                  </tr>
                ))
            )}
          </tbody>
        </Table>

        {/* Entries Info */}
        <div className="d-flex justify-content-between align-items-center mt-3">
          <div className="text-muted">
            Showing {((returnCurrentPage - 1) * returnEntriesToShow) + 1} to {Math.min(returnCurrentPage * returnEntriesToShow, filteredVendorReturnData.length)} of {filteredVendorReturnData.length} entries
          </div>
        </div>

        <nav className="mt-3">
          <ul className="pagination justify-content-center">
            <li className="page-item">
              <a
                href="#"
                className="page-link"
                style={{ color: "#d86f89" }}
                onClick={returnPrevPage}
                disabled={returnCurrentPage === 1}
              >
                Prev
              </a>
            </li>
            <li className="page-item">
              <a
                href="#"
                className="page-link"
                style={{ color: "#d86f89" }}
                onClick={returnNextPage}
                disabled={
                  returnCurrentPage ===
                  Math.ceil(filteredVendorReturnData.length / returnEntriesToShow)
                }
              >
                Next
              </a>
            </li>
          </ul>
        </nav>
      </CardBody>
    </Card>
  </Col>
</Row>

          <Modal
            isOpen={showDeleteConfirmation}
            toggle={() => setShowDeleteConfirmation(false)}
          >
            <ModalHeader>Confirm Deletion</ModalHeader>
            <ModalBody>
              Are you sure you want to delete this material ?
            </ModalBody>
            <div className="modal-footer">
              <Button color="danger" onClick={handleDeleteConfirmation}>
                Yes
              </Button>
              <Button
                color="secondary"
                onClick={() => setShowDeleteConfirmation(false)}
              >
                No
              </Button>
            </div>
          </Modal>

          <Modal isOpen={showRoleModal} toggle={toggleRole}>
            <ModalHeader toggle={toggleRole}>
              <h2 style={{ fontWeight: "bolder", textTransform: "uppercase" }}>
                New Stock
              </h2>
            </ModalHeader>
            <ModalBody>
              {addStockMessage.text && (
                <Alert color={addStockMessage.type}>
                  {addStockMessage.text}
                </Alert>
              )}
              <Form onSubmit={handleFormSubmit}>
                <Row className="mb-4">
                  <Col md={6}>
                    <label className="form-control-label" htmlFor="input-role">
                      Enter Product Name
                    </label>
                    <Input
                      name="product_name"
                      className="form-control-alternative"
                      id="input-role"
                      type="text"
                      onChange={handleInputChange}
                      placeholder="Enter Product Name"
                      required
                    />
                  </Col>
                  <Col md={6}>
                    <label className="form-control-label" htmlFor="input-role">
                      Enter Total Stock
                    </label>
                    <Input
                      className="form-control-alternative"
                      id="input-role"
                      type="number"
                      name="total_stock"
                      onChange={handleInputChange}
                      placeholder="Enter Total Stock"
                      min="0"
                      step="1"
                      required
                    />
                  </Col>
                </Row>
                <Row className="mb-4">
                  <Col md={6}>
                    <label className="form-control-label" htmlFor="input-role">
                      Enter Current Stock
                    </label>
                    <Input
                      className="form-control-alternative"
                      id="input-role"
                      type="number"
                      name="available_stock"
                      onChange={handleInputChange}
                      placeholder="Enter Current Stock"
                      min="0"
                      step="1"
                      required
                    />
                  </Col>
                  <Col md={6}>
                    <label className="form-control-label" htmlFor="input-role">
                      Enter Cost / Unit
                    </label>
                    <Input
                      className="form-control-alternative"
                      id="input-role"
                      type="number"
                      name="cost"
                      onChange={handleInputChange}
                      placeholder="Enter Cost/Unit"
                      min="0"
                      step="0.01"
                      required
                    />
                  </Col>
                </Row>

                <Row>
                  <Col lg="12" style={{ textAlign: "center" }}>
                    <Button
                      style={{
                        backgroundColor: "#d86f89",
                        borderColor: "#d86f89",
                        color: "black",
                      }}
                      type="submit"
                    >
                      Submit
                    </Button>
                  </Col>
                </Row>
              </Form>
            </ModalBody>
          </Modal>

          <Modal isOpen={showRoleModal2} toggle={toggleRole2}>
            <ModalHeader toggle={toggleRole2}>
              <h2 style={{ fontWeight: "bolder", textTransform: "uppercase" }}>
                Delivery Stock
              </h2>
            </ModalHeader>
            <ModalBody>
              {addStockMessage.text && (
                <Alert color={addStockMessage.type}>
                  {addStockMessage.text}
                </Alert>
              )}
              <Form onSubmit={handleFormSubmit2}>
                <Row className="mb-4">
                  <Col md={6}>
                    <label className="form-control-label" htmlFor="input-role">
                      Select Project
                    </label>
                    {!addstock2.p_id ? (
                      <Dropdown isOpen={deliveryModalProjectDropdownOpen} toggle={() => setDeliveryModalProjectDropdownOpen(!deliveryModalProjectDropdownOpen)}>
                        <DropdownToggle caret style={{ width: '100%', textAlign: 'left' }}>
                          {addstock2.p_id ? projects.find(p => p.p_id === addstock2.p_id)?.p_name : "Select Project"}
                        </DropdownToggle>
                        <DropdownMenu style={{ width: '100%', padding: '8px', maxHeight: '250px', overflowY: 'auto' }}>
                          {/* Search Bar Inside Dropdown */}
                          <div className="mb-2">
                            <Input
                              type="text"
                              placeholder="Search projects..."
                              value={deliveryModalProjectSearch || ''}
                              onChange={(e) => setDeliveryModalProjectSearch(e.target.value)}
                              style={{ fontSize: '13px', height: '32px' }}
                            />
                          </div>
                          <DropdownItem onClick={() => {
                            setAddStock2(prev => ({ ...prev, p_id: "" }));
                            setDeliveryModalProjectDropdownOpen(false);
                          }}>
                            All Projects
                          </DropdownItem>
                          {projects
                            .filter(project => 
                              !deliveryModalProjectSearch || 
                              project.p_name.toLowerCase().includes(deliveryModalProjectSearch.toLowerCase())
                            )
                            .sort((a, b) => {
                              const idA = parseInt(a.p_id) || 0;
                              const idB = parseInt(b.p_id) || 0;
                              return idB - idA; // Descending order (newest first)
                            })
                            .map((project) => (
                              <DropdownItem 
                                key={project.p_id}
                                onClick={() => {
                                  setAddStock2(prev => ({ ...prev, p_id: project.p_id }));
                                  setDeliveryModalProjectDropdownOpen(false);
                                }}
                                style={{ padding: '6px 12px', fontSize: '13px' }}
                              >
                                {project.p_name}
                              </DropdownItem>
                            ))}
                        </DropdownMenu>
                      </Dropdown>
                    ) : (
                      <div className="d-flex align-items-center justify-content-between p-2" style={{ 
                        backgroundColor: '#f8f9fa', 
                        border: '1px solid #ced4da', 
                        borderRadius: '0.375rem',
                        minHeight: 'calc(2.75rem + 2px)'
                      }}>
                        <span style={{ fontSize: '0.75rem' }}>
                          {projects.find(p => p.p_id === addstock2.p_id)?.p_name}
                        </span>
                        <Button 
                          size="sm" 
                          color="link" 
                          onClick={() => setAddStock2(prev => ({ ...prev, p_id: "" }))}
                          style={{ padding: '0', margin: '0', fontSize: '12px' }}
                        >
                          <i className="fas fa-times"></i>
                        </Button>
                      </div>
                    )}
                  </Col>
                  <Col md={6}>
                    <label className="form-control-label" htmlFor="input-role">
                      Enter Product Name
                    </label>
                    {addstock2.p_id ? (
                      <Dropdown isOpen={deliveryModalProductDropdownOpen} toggle={() => setDeliveryModalProductDropdownOpen(!deliveryModalProductDropdownOpen)}>
                        <DropdownToggle caret style={{ width: '100%', textAlign: 'left' }}>
                          {addstock2.product_name || "Select Product"}
                        </DropdownToggle>
                        <DropdownMenu style={{ width: '100%', padding: '8px', maxHeight: '250px', overflowY: 'auto' }}>
                          {/* Search Bar Inside Product Dropdown */}
                          <div className="mb-2">
                            <Input
                              type="text"
                              placeholder="Search products..."
                              value={deliveryModalProductSearch || ''}
                              onChange={(e) => setDeliveryModalProductSearch(e.target.value)}
                              style={{ fontSize: '13px', height: '32px' }}
                            />
                          </div>
                          <DropdownItem onClick={() => {
                            setAddStock2(prev => ({ ...prev, product_name: "" }));
                            setDeliveryModalProductDropdownOpen(false);
                          }}>
                            All Products
                          </DropdownItem>
                          {originalData
                            .filter(item => 
                              !deliveryModalProductSearch || 
                              item.product_name.toLowerCase().includes(deliveryModalProductSearch.toLowerCase())
                            )
                            .map((item) => (
                              <DropdownItem 
                          key={item.product_id}
                                onClick={() => {
                                  setAddStock2(prev => ({ ...prev, product_name: item.product_name }));
                                  setDeliveryModalProductDropdownOpen(false);
                                }}
                                style={{ padding: '6px 12px', fontSize: '13px' }}
                        >
                          {item.product_name}
                              </DropdownItem>
                            ))}
                        </DropdownMenu>
                      </Dropdown>
                    ) : (
                      <div className="p-2" style={{ 
                        backgroundColor: '#f8f9fa', 
                        border: '1px solid #ced4da', 
                        borderRadius: '0.375rem',
                        minHeight: 'calc(2.75rem + 2px)',
                        display: 'flex',
                        alignItems: 'center',
                        color: '#6c757d',
                        fontSize: '0.875rem'
                      }}>
                        Please select a project first
                      </div>
                    )}
                  </Col>
                </Row>
                <Row className="mb-4">
                  <Col md={6}>
                    <label className="form-control-label" htmlFor="input-role">
                      Enter Quantity Delivered
                    </label>
                    <Input
                      className="form-control-alternative"
                      id="input-role"
                      type="number"
                      name="quantity_delivered"
                      onChange={handleInputChange}
                      placeholder="Enter Quantity"
                      min="1"
                      step="1"
                      required
                    />
                    {originalData.map((item) => (
                      <div key={item.product_id}>
                        {item.product_name === addstock2.product_name && (
                          <h3
                            style={{
                              color: "red",
                              fontSize: "15px",
                              fontWeight: "bold",
                              marginTop: "10px",
                              textAlign: "start",
                            }}
                          >
                            Available Stock: {item.available_stock}
                          </h3>
                        )}
                      </div>
                    ))}
                  </Col>
                  <Col md={6}>
                    <label className="form-control-label" htmlFor="input-role">
                      Enter Delivery Date
                    </label>
                    <Input
                      className="form-control-alternative"
                      id="input-role"
                      type="date"
                      name="delivery_date"
                      onChange={handleInputChange}
                      required
                    />
                  </Col>
                </Row>
                <Row className="mb-4">
                  <Col md={6}>
                    <label className="form-control-label" htmlFor="input-role">
                      Enter Delivered To
                    </label>
                    <Input
                      className="form-control-alternative"
                      id="input-role"
                      type="text"
                      name="delivered_to_name"
                      onChange={handleInputChange}
                      placeholder="Enter Delivered To"
                      required
                    />
                  </Col>
                  <Col md={6}>
                    <label className="form-control-label" htmlFor="input-role">
                      Enter Cost / Unit
                    </label>
                    <Input
                      className="form-control-alternative"
                      id="input-role"
                      type="number"
                      name="product_cost"
                      step="0.01"
                      min="0"
                      onChange={handleInputChange}
                      placeholder="Enter Cost/Unit (e.g., 200.50)"
                      required
                      style={{ fontSize: '0.875rem' }}
                      inputMode="decimal"
                    />
                  </Col>
                </Row>
                <Row className="mb-4">
                  <Col md={6}>
                    <label className="form-control-label" htmlFor="input-role">
                      Material Tracking Number
                    </label>
                    <Input
                      className="form-control-alternative"
                      id="input-role"
                      type="text"
                      name="material_tracking_number"
                      onChange={handleInputChange}
                      placeholder="Enter Material Tracking Number"
                      required
                    />
                  </Col>
                </Row>
                <Row>
                  <Col lg="12" style={{ textAlign: "center" }}>
                    <Button
                      style={{
                        backgroundColor: "#d86f89",
                        borderColor: "#d86f89",
                        color: "black",
                      }}
                      type="submit"
                    >
                      Submit
                    </Button>
                  </Col>
                </Row>
              </Form>
            </ModalBody>
          </Modal>

          <Modal isOpen={modalImport} toggle={toggleModalImport}>
            <ModalHeader toggle={toggleModalImport}>
              <h2 style={{ fontWeight: "bolder", textTransform: "uppercase" }}>
                Add Multiple Materials
              </h2>
            </ModalHeader>
            <ModalBody>
              {/* Display Upload Messages */}
              {/* {uploadMessage.text && (
            <Alert color={uploadMessage.type}>{uploadMessage.text}</Alert>
          )} */}

              <Form onSubmit={handleImportSubmit}>
                <div className="alert mb-3" style={{ backgroundColor: '#f8f9fa', borderColor: '#d86f89', color: '#495057' }}>
                  <h6><i className="fas fa-info-circle mr-2" style={{ color: '#d86f89' }}></i>Instructions:</h6>
                  <ul className="mb-0">
                    <li>Upload an Excel or CSV file with columns: Product Name, Total Stock, Current Stock, Cost</li>
                    <li>First row should contain headers</li>
                    <li>Supported formats: .xlsx, .xls, .csv</li>
                  </ul>
                </div>
                <FormGroup>
                  <Label for="importFile">
                    Upload Excel/CSV File (.csv, .xls, .xlsx)
                  </Label>
                  <Input
                    type="file"
                    // Use the name PHP expects for clarity, although formData.append sets the key
                    name="excel_file"
                    id="importFile"
                    accept=".csv, .xls, .xlsx, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, text/csv"
                    onChange={handleImportFileUpload}
                    disabled={isUploading} // Disable input while uploading
                  />
                  {importedFileDetails &&
                    !isUploading && ( // Hide details while uploading
                      <div className="mt-2">
                        <small>
                          File: {importedFileDetails.fileName} | Selected at:{" "}
                          {importedFileDetails.uploadTime}
                        </small>
                      </div>
                    )}
                </FormGroup>
                <div className="text-center">
                  <Button
                    style={{
                      backgroundColor: "#d86f89",
                      borderColor: "#d86f89",
                      color: "black",
                    }}
                    type="submit"
                    disabled={isUploading || !selectedFile}
                  >
                    {isUploading ? "Importing..." : "Import"}
                  </Button>
                </div>
              </Form>
            </ModalBody>
          </Modal>

          <Modal isOpen={showRoleModal3} toggle={toggleRole3}>
            <ModalHeader toggle={toggleRole3}>
              <h2 style={{ fontWeight: "bolder", textTransform: "uppercase" }}>
                Return Stock
              </h2>
            </ModalHeader>
            <ModalBody>
              {addStockMessage.text && (
                <Alert color={addStockMessage.type}>
                  {addStockMessage.text}
                </Alert>
              )}

              <Form onSubmit={handleReturnSubmit}>
                <Row className="mb-4">
                  <Col md={6}>
                    <label className="form-control-label" htmlFor="input-role">
                      Select Product
                    </label>
                    <Dropdown isOpen={singleReturnProductDropdownOpen} toggle={toggleSingleReturnProductDropdown}>
                      <DropdownToggle caret style={{ width: '100%', textAlign: 'left' }}>
                        {addstock3.product_name || "Select Product"}
                      </DropdownToggle>
                      <DropdownMenu style={{ width: '100%', padding: '8px', maxHeight: '250px', overflowY: 'auto' }}>
                        {/* Search Bar */}
                        <div className="mb-2">
                          <Input
                            type="text"
                            placeholder="Search products..."
                            value={singleReturnProductSearch || ''}
                            onChange={(e) => setSingleReturnProductSearch(e.target.value)}
                            style={{ fontSize: '13px', height: '32px' }}
                          />
                        </div>
                        <DropdownItem onClick={() => handleProductSelect("")} style={{ padding: '6px 12px', fontSize: '13px' }}>
                          All Products
                        </DropdownItem>
                        {[
                          ...new Set(
                            materialDeliveryData.map((item) => item.product_name)
                          ),
                        ]
                          .filter(productName => 
                            !singleReturnProductSearch || 
                            productName.toLowerCase().includes(singleReturnProductSearch.toLowerCase())
                          )
                          .map((productName, index) => (
                            <DropdownItem 
                              key={index} 
                              onClick={() => {
                                handleProductSelect(productName);
                                setSingleReturnProductSearch("");
                              }}
                              style={{ padding: '6px 12px', fontSize: '13px' }}
                            >
                              {productName}
                            </DropdownItem>
                          ))}
                      </DropdownMenu>
                    </Dropdown>
                  </Col>
                  <Col md={6}>
                    <label className="form-control-label" htmlFor="input-role">
                      Select Project
                    </label>
                    <Dropdown isOpen={singleReturnProjectDropdownOpen} toggle={toggleSingleReturnProjectDropdown}>
                      <DropdownToggle 
                        caret 
                        style={{ width: '100%', textAlign: 'left' }}
                        disabled={!addstock3.product_name}
                      >
                        {addstock3.p_id ? selectedProductProjects.find(p => p.p_id === addstock3.p_id)?.p_name : "Select Project"}
                      </DropdownToggle>
                      <DropdownMenu style={{ width: '100%', padding: '8px', maxHeight: '250px', overflowY: 'auto' }}>
                        {/* Search Bar */}
                        <div className="mb-2">
                          <Input
                            type="text"
                            placeholder="Search projects..."
                            value={singleReturnProjectSearch || ''}
                            onChange={(e) => setSingleReturnProjectSearch(e.target.value)}
                            style={{ fontSize: '13px', height: '32px' }}
                          />
                        </div>
                        <DropdownItem onClick={() => handleProjectSelect("")} style={{ padding: '6px 12px', fontSize: '13px' }}>
                          All Projects
                        </DropdownItem>
                        {selectedProductProjects
                          .filter(project => 
                            !singleReturnProjectSearch || 
                            project.p_name.toLowerCase().includes(singleReturnProjectSearch.toLowerCase())
                          )
                          .map((project) => (
                            <DropdownItem 
                              key={project.p_id} 
                              onClick={() => {
                                handleProjectSelect(project.p_id);
                                setSingleReturnProjectSearch("");
                              }}
                              style={{ padding: '6px 12px', fontSize: '13px' }}
                            >
                              {project.p_name}
                            </DropdownItem>
                          ))}
                      </DropdownMenu>
                    </Dropdown>
                  </Col>
                </Row>
                <Row className="mb-4">
                  <Col md={6}>
                    <label className="form-control-label" htmlFor="input-role">
                      Material Tracking Number
                    </label>
                    <select
                      name="material_tracking_number"
                      className="form-select form-control-alternative custom-select"
                      id="input-role"
                      onChange={(e) =>
                        handleTrackingNumberSelect(e.target.value)
                      }
                      required
                      disabled={!addstock3.p_id}
                      style={{
                        padding: "0.75rem 1rem",
                        fontSize: "0.875rem",
                        fontWeight: "400",
                        lineHeight: "1.5",
                        color: "#495057",
                        backgroundColor: "#fff",
                        backgroundClip: "padding-box",
                        border: "1px solid #ced4da",
                        borderRadius: "0.375rem",
                        transition:
                          "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
                        height: "calc(2.75rem + 2px)",
                        width: "100%",
                      }}
                    >
                      <option value="">Select Tracking Number</option>
                      {selectedProjectTracking.map((item, index) => (
                        <option
                          key={index}
                          value={item.material_tracking_number}
                          style={{
                            padding: "0.5rem 1rem",
                            fontSize: "0.875rem",
                          }}
                        >
                          {item.material_tracking_number}
                        </option>
                      ))}
                    </select>
                    {selectedDeliveryInfo && (
                      <div className="mt-2">
                        <small className="text-muted">
                          Delivered to: {selectedDeliveryInfo.delivered_to_name}
                        </small>
                      </div>
                    )}
                  </Col>
                  <Col md={6}>
                    <label className="form-control-label" htmlFor="input-role">
                      Enter Quantity Returned
                    </label>
                    <Input
                      className="form-control-alternative"
                      id="input-role"
                      type="number"
                      name="quantity_returned"
                      onChange={(e) => {
                        handleInputChange(e);
                        // Auto-calculate yet_to_returned based on remaining quantity
                        const returnedQty = parseInt(e.target.value) || 0;
                        const deliveredQty = selectedDeliveryInfo ? parseInt(selectedDeliveryInfo.quantity_delivered) || 0 : 0;
                        
                        // Calculate previously returned quantity for this tracking number
                        const previouslyReturned = vendorReturnData
                          .filter(item => item.material_tracking_number === addstock3.material_tracking_number)
                          .reduce((sum, item) => sum + parseInt(item.quantity_returned || 0), 0);
                        
                        // Calculate remaining quantity that can still be returned
                        const remainingQty = Math.max(0, deliveredQty - previouslyReturned);
                        
                        // Calculate final yet_to_returned after this return
                        const finalYetToReturn = Math.max(0, remainingQty - returnedQty);
                        
                        // Debug logging
                        console.log('Yet to Return Calculation:', {
                          deliveredQty,
                          previouslyReturned,
                          remainingQty,
                          returnedQty,
                          finalYetToReturn
                        });
                        
                        setAddStock3(prev => ({
                          ...prev,
                          yet_to_returned: finalYetToReturn.toString()
                        }));
                      }}
                      placeholder="Enter Quantity Returned"
                      min="1"
                      step="1"
                      required
                    />
                    {selectedDeliveryInfo && (
                      <div className="mt-2">
                        {(() => {
                          const deliveredQty = parseInt(selectedDeliveryInfo.quantity_delivered) || 0;
                          const previouslyReturned = vendorReturnData
                            .filter(item => item.material_tracking_number === addstock3.material_tracking_number)
                            .reduce((sum, item) => sum + parseInt(item.quantity_returned || 0), 0);
                          const remainingQty = Math.max(0, deliveredQty - previouslyReturned);
                          const currentReturned = parseInt(addstock3.quantity_returned || 0);
                          
                          return (
                            <>
                              <small className="text-muted">
                                <strong>Total Delivered: {deliveredQty}</strong>
                              </small>
                              <br />
                              <small style={{ color: '#666' }}>
                                <strong>Previously Returned: {previouslyReturned}</strong>
                              </small>
                              <br />
                              <small style={{ color: '#888' }}>
                                <i className="fas fa-info-circle mr-1"></i>
                                Remaining to Return = {remainingQty} - Current Return
                              </small>
                              {currentReturned > remainingQty && (
                                <>
                                  <br />
                                  <small style={{ color: '#dc3545', fontWeight: 'bold' }}>
                                    <i className="fas fa-exclamation-triangle mr-1"></i>
                                    Warning: Returned quantity exceeds remaining quantity!
                                  </small>
                                </>
                              )}
                            </>
                          );
                        })()}
                      </div>
                    )}
                  </Col>
                </Row>
                <Row className="mb-4">
                  <Col md={6}>
                    <label className="form-control-label" htmlFor="input-role">
                      Yet To Return (Auto-calculated)
                    </label>
                    <Input
                      className="form-control-alternative"
                      id="input-role"
                      type="number"
                      name="yet_to_returned"
                      value={addstock3.yet_to_returned || ''}
                      onChange={handleInputChange}
                      placeholder="Auto-calculated"
                      readOnly
                      style={{ backgroundColor: '#f8f9fa', cursor: 'not-allowed' }}
                    />
                    {selectedDeliveryInfo && (
                      <div className="mt-2">
                        {(() => {
                          const deliveredQty = parseInt(selectedDeliveryInfo.quantity_delivered) || 0;
                          const previouslyReturned = vendorReturnData
                            .filter(item => item.material_tracking_number === addstock3.material_tracking_number)
                            .reduce((sum, item) => sum + parseInt(item.quantity_returned || 0), 0);
                          const remainingQty = Math.max(0, deliveredQty - previouslyReturned);
                          const currentReturned = parseInt(addstock3.quantity_returned || 0);
                          const finalYetToReturn = Math.max(0, remainingQty - currentReturned);
                          
                          return (
                            <>
                              <small className="text-muted">
                                <strong>Total Delivered:</strong> {deliveredQty}
                              </small>
                              <br />
                              <small style={{ color: '#666' }}>
                                <strong>Previously Returned:</strong> {previouslyReturned}
                              </small>
                              <br />
                              <small style={{ color: '#888' }}>
                                <strong>Remaining to Return:</strong> {remainingQty}
                              </small>
                              <br />
                              <small style={{ color: '#d86f89', fontWeight: 'bold' }}>
                                <strong>Final Yet to Return:</strong> {remainingQty} - {currentReturned} = {finalYetToReturn}
                              </small>
                            </>
                          );
                        })()}
                      </div>
                    )}
                  </Col>
                  <Col md={6}>
                    <label className="form-control-label" htmlFor="input-role">
                      Enter Return Date
                    </label>
                    <Input
                      className="form-control-alternative"
                      id="input-role"
                      type="date"
                      name="return_date"
                      onChange={handleInputChange}
                      required
                    />
                  </Col>
                </Row>
                <Row className="mb-4">
                  <Col md={6}>
                    <label className="form-control-label" htmlFor="input-role">
                      Enter Returned By
                    </label>
                    <select
                      name="returned_by"
                      className="form-select form-control-alternative custom-select"
                      id="input-role"
                      onChange={handleInputChange}
                      required
                      disabled={!addstock3.p_id}
                      style={{
                        padding: "0.75rem 1rem",
                        fontSize: "0.875rem",
                        fontWeight: "400",
                        lineHeight: "1.5",
                        color: "#495057",
                        backgroundColor: "#fff",
                        backgroundClip: "padding-box",
                        border: "1px solid #ced4da",
                        borderRadius: "0.375rem",
                        transition:
                          "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
                        height: "calc(2.75rem + 2px)",
                        width: "100%",
                      }}
                    >
                      <option value="">Select Client</option>
                      {[
                        ...new Set(
                          selectedProjectTracking.map(
                            (item) => item.delivered_to_name
                          )
                        ),
                      ].map((clientName, index) => (
                        <option
                          key={index}
                          value={clientName}
                          style={{
                            padding: "0.5rem 1rem",
                            fontSize: "0.875rem",
                          }}
                        >
                          {clientName}
                        </option>
                      ))}
                    </select>
                  </Col>
                </Row>
                <Row>
                  <Col lg="12" style={{ textAlign: "center" }}>
                    <Button
                      style={{
                        backgroundColor: "#d86f89",
                        borderColor: "#d86f89",
                        color: "black",
                      }}
                      type="submit"
                    >
                      Submit
                    </Button>
                  </Col>
                </Row>
              </Form>
            </ModalBody>
          </Modal>

          {/* Project Report Section */}
          <Row className="mt-4">
            <Col xl="12">
              <Card style={{
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                backgroundColor: "#fff",
                borderRadius: "15px",
              }}>
                <CardBody>
                  <CardHeader className="border-0">
                    <Row className="align-items-center">
                      <div className="col-12 d-flex justify-content-between align-items-center">
                        <h3 className="mb-0">Project Report</h3>
                        <div className="d-flex align-items-center" style={{ flexWrap: 'nowrap', gap: '8px' }}>
                          {/* Generate Report Button */}
                          <Button
                            style={{
                              backgroundColor: "#d86f89",
                              borderColor: "#d86f89",
                              color: "black",
                            }}
                            onClick={generateProjectReport}
                            disabled={projectReportGenerating || projectReportLoading}
                          >
                            {projectReportGenerating ? "Generating..." : "Generate Report"}
                          </Button>

                          {/* Export CSV Button */}
                          <Button
                            style={{
                              backgroundColor: "#17a2b8",
                              borderColor: "#17a2b8",
                              color: "white",
                            }}
                            onClick={exportProjectReportToCSV}
                            disabled={filteredProjectReports.length === 0 || projectReportLoading}
                          >
                            Export CSV
                          </Button>
                        </div>
                      </div>
                    </Row>
                  </CardHeader>

                  {/* Project Report Message */}
                  {projectReportMessage && (
                    <Alert color={projectReportMessageType} className="mt-3">
                      {projectReportMessage}
                    </Alert>
                  )}

                  {/* Filters Section */}
                  <div className="mb-3 p-3" style={{ backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
                    <Row className="align-items-center">
                      <Col md="4">
                        <Label className="form-control-label">Project Filter:</Label>
                        <Dropdown isOpen={projectReportProjectDropdownOpen} toggle={() => setProjectReportProjectDropdownOpen(!projectReportProjectDropdownOpen)}>
                          <DropdownToggle caret style={{ width: '100%', textAlign: 'left' }}>
                            {selectedProjectReportProject ? 
                              projects.find(p => p.p_id === selectedProjectReportProject)?.p_name : 
                              "All Projects"
                            }
                          </DropdownToggle>
                          <DropdownMenu style={{ width: '100%', padding: '8px', maxHeight: '250px', overflowY: 'auto' }}>
                            {/* Search Bar Inside Dropdown */}
                            <div className="mb-2">
                              <Input
                                type="text"
                                placeholder="Search projects..."
                                value={projectReportProjectSearch || ''}
                                onChange={(e) => setProjectReportProjectSearch(e.target.value)}
                                style={{ fontSize: '13px', height: '32px' }}
                              />
                            </div>
                            <DropdownItem onClick={() => setSelectedProjectReportProject('')} style={{ padding: '6px 12px', fontSize: '13px' }}>
                              All Projects
                            </DropdownItem>
                            {projects
                              .filter(project => 
                                !projectReportProjectSearch || 
                                project.p_name.toLowerCase().includes(projectReportProjectSearch.toLowerCase())
                              )
                              .map((project) => (
                                <DropdownItem 
                                  key={project.p_id} 
                                  onClick={() => setSelectedProjectReportProject(project.p_id)}
                                  style={{ padding: '6px 12px', fontSize: '13px' }}
                                >
                                  {project.p_name}
                                </DropdownItem>
                              ))}
                          </DropdownMenu>
                        </Dropdown>
                      </Col>
                      <Col md="4">
                        <Label className="form-control-label">Product Search:</Label>
                        <Input
                          type="text"
                          placeholder="Search products..."
                          value={projectReportProductSearch}
                          onChange={(e) => setProjectReportProductSearch(e.target.value)}
                          style={{ width: '100%' }}
                        />
                      </Col>
                      <Col md="4">
                        <div className="d-flex gap-2 align-items-end">
                          <Button
                            color="secondary"
                            size="sm"
                            onClick={clearProjectReportFilters}
                            style={{ marginTop: '25px' }}
                          >
                            Clear Filters
                          </Button>
                          
                          {/* Show Entries Dropdown */}
                          <div className="d-flex align-items-center gap-2" style={{ marginTop: '25px' }}>
                            <span style={{ fontSize: '14px' }}>Show Entries:</span>
                            <Dropdown isOpen={projectReportEntriesDropdownOpen} toggle={() => setProjectReportEntriesDropdownOpen(!projectReportEntriesDropdownOpen)}>
                              <DropdownToggle caret size="sm">
                                {projectReportEntriesPerPage === filteredProjectReports.length ? "All" : projectReportEntriesPerPage}
                              </DropdownToggle>
                              <DropdownMenu>
                                <DropdownItem onClick={() => handleProjectReportEntriesChange(5)}>5</DropdownItem>
                                <DropdownItem onClick={() => handleProjectReportEntriesChange(10)}>10</DropdownItem>
                                <DropdownItem onClick={() => handleProjectReportEntriesChange(25)}>25</DropdownItem>
                                <DropdownItem onClick={() => handleProjectReportEntriesChange("All")}>All</DropdownItem>
                              </DropdownMenu>
                            </Dropdown>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>

                  {/* Project Report Table */}
                  <Table className="align-items-center table-flush" responsive>
                    <thead className="thead-light">
                      <tr>
                        <th scope="col">S.No</th>
                        <th scope="col">Project Name</th>
                        <th scope="col">Product Name</th>
                        <th scope="col">Delivered Quantity</th>
                        <th scope="col">Returned Quantity</th>
                        <th scope="col">Yet To Return</th>
                      </tr>
                    </thead>
                    <tbody style={{ textAlign: "center" }}>
                      {projectReportLoading ? (
                        <tr>
                          <td colSpan="6" style={{ color: '#888', fontWeight: 'bold' }}>
                            Loading project reports...
                          </td>
                        </tr>
                      ) : projectReportPaginatedData.length === 0 ? (
                        <tr>
                          <td colSpan="6" style={{ color: '#888', fontWeight: 'bold' }}>
                            {projectReports.length === 0 ? 'No project reports available. Click "Generate Report" to create one.' : 'No data matches the current filters.'}
                          </td>
                        </tr>
                      ) : (
                        projectReportPaginatedData.map((report, index) => (
                          <tr key={report.report_id || index}>
                            <th scope="row">
                              {(projectReportCurrentPage - 1) * projectReportEntriesPerPage + index + 1}
                            </th>
                            <td>{report.project_name}</td>
                            <td>{report.product_name}</td>
                            <td>{report.delivered_quantity}</td>
                            <td>{report.returned_quantity}</td>
                            <td>{report.yet_to_return}</td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </Table>

                  {/* Entries Info */}
                  <div className="d-flex justify-content-between align-items-center mt-3">
                    <div className="text-muted">
                      Showing {((projectReportCurrentPage - 1) * projectReportEntriesPerPage) + 1} to {Math.min(projectReportCurrentPage * projectReportEntriesPerPage, filteredProjectReports.length)} of {filteredProjectReports.length} entries
                    </div>
                  </div>

                  {/* Pagination */}
                  <nav className="mt-3">
                    <ul className="pagination justify-content-center">
                      <li className="page-item">
                        <a
                          href="#"
                          className="page-link"
                          style={{ color: "#d86f89" }}
                          onClick={(e) => {
                            e.preventDefault();
                            projectReportPrevPage();
                          }}
                          disabled={projectReportCurrentPage === 1}
                        >
                          Prev
                        </a>
                      </li>
                      <li className="page-item">
                        <a
                          href="#"
                          className="page-link"
                          style={{ color: "#d86f89" }}
                          onClick={(e) => {
                            e.preventDefault();
                            projectReportNextPage();
                          }}
                          disabled={projectReportCurrentPage === Math.ceil(filteredProjectReports.length / projectReportEntriesPerPage)}
                        >
                          Next
                        </a>
                      </li>
                    </ul>
                  </nav>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      {showSuccessAlert && (
        <div style={{
          position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex',
          justifyContent: 'center', alignItems: 'flex-start', paddingTop: '15%', zIndex: 9999
        }}>
          <div style={{
            backgroundColor: '#fff', padding: '30px', borderRadius: '15px',
            boxShadow: '0 10px 30px rgba(0,0,0,0.3)', textAlign: 'center',
            maxWidth: '600px', width: '90%', 
            border: alertType === 'success' ? '3px solid #d86f89' : '3px solid #dc3545'
          }}>
            <div style={{ 
              fontSize: '48px', 
              color: alertType === 'success' ? '#d86f89' : '#dc3545', 
              marginBottom: '20px' 
            }}>
              {alertType === 'success' ? '✓' : '✗'}
            </div>
            <h4 style={{ 
              color: alertType === 'success' ? '#28a745' : '#dc3545', 
              marginBottom: '15px' 
            }}>
              {alertType === 'success' ? 'Success!' : 'Error!'}
            </h4>
            <div style={{ 
              color: '#333', 
              fontSize: '14px', 
              marginBottom: '20px', 
              textAlign: 'left',
              whiteSpace: 'pre-line',
              maxHeight: '300px',
              overflowY: 'auto',
              padding: '10px',
              backgroundColor: '#f8f9fa',
              borderRadius: '8px',
              border: '1px solid #e9ecef'
            }}>
              {successMessage}
            </div>
            <Button
              style={{
                backgroundColor: alertType === 'success' ? '#d86f89' : '#dc3545', 
                borderColor: alertType === 'success' ? '#d86f89' : '#dc3545', 
                color: 'white',
                padding: '10px 25px', borderRadius: '25px'
              }}
              onClick={() => {
                setShowSuccessAlert(false);
                if (alertType === 'success') {
                  window.location.reload();
                }
              }}
            >OK</Button>
          </div>
        </div>
      )}

<Modal isOpen={showMultiDeliveryModal} toggle={() => setShowMultiDeliveryModal(false)}>
            <ModalHeader toggle={() => setShowMultiDeliveryModal(false)}>
              <h2 style={{ fontWeight: "bolder", textTransform: "uppercase" }}>
                Multiple Material Delivery
              </h2>
            </ModalHeader>
            <ModalBody>
              {multiDeliveryMessage.text && (
                <Alert color={multiDeliveryMessage.type}>
                  {multiDeliveryMessage.text}
                </Alert>
              )}
              
              <div className="alert mb-3" style={{ backgroundColor: '#f8f9fa', borderColor: '#d86f89', color: '#495057' }}>
                <h6><i className="fas fa-info-circle mr-2" style={{ color: '#d86f89' }}></i>Instructions:</h6>
                <ul className="mb-0">
                  <li>Upload an Excel or CSV file with columns: <strong>material_name, quantity_delivered, cost, material_tracking_number</strong></li>
                  <li>First row should contain headers exactly as shown above</li>
                  <li>Material tracking number must be exactly 6 characters (letters/numbers)</li>
                  <li>Quantity and cost must be positive numbers</li>
                  <li>Supported formats: .xlsx, .xls, .csv</li>
                  <li>Maximum file size: 5MB</li>
                </ul>
              </div>

              <Form onSubmit={handleMultiDeliverySubmit}>
                <Row className="mb-4">
                  <Col md={6}>
                    <Label for="multiProject">Select Project</Label>
                    <Dropdown isOpen={multiDeliveryProjectDropdownOpen} toggle={() => setMultiDeliveryProjectDropdownOpen(!multiDeliveryProjectDropdownOpen)}>
                      <DropdownToggle caret style={{ width: '100%', textAlign: 'left' }}>
                        {multiDelivery.p_id ? (
                          <span style={{ color: '#495057' }}>
                            {projects.find(p => p.p_id === multiDelivery.p_id)?.p_name}
                          </span>
                        ) : (
                          <span style={{ color: '#6c757d' }}>Select Project</span>
                        )}
                      </DropdownToggle>
                      <DropdownMenu style={{ width: '100%', padding: '8px', maxHeight: '250px', overflowY: 'auto' }}>
                        {/* Search Bar Inside Dropdown */}
                        <div className="mb-2">
                          <Input
                            type="text"
                            placeholder="Search projects..."
                            value={multiDeliveryProjectSearch || ''}
                            onChange={(e) => setMultiDeliveryProjectSearch(e.target.value)}
                            style={{ fontSize: '13px', height: '32px' }}
                          />
                        </div>
                        <DropdownItem onClick={() => {
                          setMultiDelivery(prev => ({ ...prev, p_id: "" }));
                          setMultiDeliveryProjectDropdownOpen(false);
                        }}>
                          All Projects
                        </DropdownItem>
                        {projects
                          .filter(project => 
                            !multiDeliveryProjectSearch || 
                            project.p_name.toLowerCase().includes(multiDeliveryProjectSearch.toLowerCase())
                          )
                          .map((project) => (
                            <DropdownItem 
                              key={project.p_id} 
                              onClick={() => {
                                setMultiDelivery(prev => ({ ...prev, p_id: project.p_id }));
                                setMultiDeliveryProjectDropdownOpen(false);
                              }}
                              style={{ padding: '6px 12px', fontSize: '13px' }}
                            >
                              {project.p_name}
                            </DropdownItem>
                          ))}
                      </DropdownMenu>
                    </Dropdown>
                    {multiDelivery.p_id && (
                      <div className="mt-2">
                        <small className="text-muted">
                          Selected Project: {projects.find(p => p.p_id === multiDelivery.p_id)?.p_name}
                        </small>
                      </div>
                    )}
                  </Col>
                  <Col md={6}>
                    <Label for="multiDeliveryDate">Enter Delivery Date</Label>
                    <Input
                      type="date"
                      id="multiDeliveryDate"
                      name="delivery_date"
                      value={multiDelivery.delivery_date}
                      onChange={handleMultiDeliveryChange}
                      required
                      disabled={isMultiDeliveryUploading}
                    />
                  </Col>
                </Row>
                <Row className="mb-4">
                  <Col md={6}>
                    <Label for="multiDeliveredTo">Enter Delivered To</Label>
                    <Input
                      type="text"
                      id="multiDeliveredTo"
                      name="delivered_to"
                      value={multiDelivery.delivered_to}
                      onChange={handleMultiDeliveryChange}
                      placeholder="Enter recipient name"
                      required
                      disabled={isMultiDeliveryUploading}
                    />
                  </Col>
                  <Col md={6}>
                    <Label for="multiFile">Upload File (.csv, .xlsx, .xls)</Label>
                    <Input
                      type="file"
                      id="multiFile"
                      name="file"
                      accept=".csv, .xlsx, .xls, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, text/csv"
                      onChange={handleMultiDeliveryChange}
                      required
                      disabled={isMultiDeliveryUploading}
                    />
                    {multiDelivery.file && (
                      <small className="text-muted mt-1 d-block">
                        Selected file: {multiDelivery.file.name}
                      </small>
                    )}
                  </Col>
                </Row>
                <Row>
                  <Col lg="12" style={{ textAlign: "center" }}>
                    <Button
                      style={{
                        backgroundColor: "#d86f89",
                        borderColor: "#d86f89",
                        color: "black",
                      }}
                      type="submit"
                      disabled={isMultiDeliveryUploading || !multiDelivery.file}
                    >
                      {isMultiDeliveryUploading ? "Uploading..." : "Submit"}
                    </Button>
                  </Col>
                </Row>
              </Form>
            </ModalBody>
          </Modal>

          <Modal isOpen={showMultiReturnModal} toggle={() => setShowMultiReturnModal(false)}>
            <ModalHeader toggle={() => setShowMultiReturnModal(false)}>
              <h2 style={{ fontWeight: "bolder", textTransform: "uppercase" }}>
                Multiple Return Materials
              </h2>
            </ModalHeader>
            <ModalBody>
              {multiReturnMessage.text && (
                <Alert color={multiReturnMessage.type}>{multiReturnMessage.text}</Alert>
              )}
              <div className="alert mb-3" style={{ backgroundColor: '#f8f9fa', borderColor: '#d86f89', color: '#495057' }}>
                <h6><i className="fas fa-info-circle mr-2" style={{ color: '#d86f89' }}></i>Instructions:</h6>
                <ul className="mb-0">
                  <li>Upload an Excel or CSV file with columns: <strong>product_name, quantity_returned, material_tracking_number</strong></li>
                  <li><strong>Note:</strong> The "yet_to_returned" field will be automatically calculated based on delivery records</li>
                  <li>First row should contain headers exactly as shown above</li>
                  <li>Supported formats: .xlsx, .xls, .csv</li>
                  <li>Maximum file size: 5MB</li>
                </ul>
              </div>
              <Form onSubmit={handleMultiReturnSubmit}>
                <Row className="mb-4">
                  <Col md={6}>
                    <Label for="multiReturnProject">Select Project</Label>
                    <Dropdown isOpen={multiReturnProjectDropdownOpen} toggle={toggleMultiReturnProjectDropdown}>
                      <DropdownToggle 
                        caret 
                        style={{ width: '100%', textAlign: 'left' }}
                        disabled={isMultiReturnUploading}
                      >
                        {multiReturn.p_id ? projects.find(p => p.p_id === multiReturn.p_id)?.p_name : "Select Project"}
                      </DropdownToggle>
                      <DropdownMenu style={{ width: '100%', padding: '8px', maxHeight: '250px', overflowY: 'auto' }}>
                        {/* Search Bar */}
                        <div className="mb-2">
                          <Input
                            type="text"
                            placeholder="Search projects..."
                            value={multiReturnProjectSearch || ''}
                            onChange={(e) => setMultiReturnProjectSearch(e.target.value)}
                            style={{ fontSize: '13px', height: '32px' }}
                          />
                        </div>
                        <DropdownItem onClick={() => handleMultiReturnProjectChange({ target: { value: "" } })} style={{ padding: '6px 12px', fontSize: '13px' }}>
                          All Projects
                        </DropdownItem>
                        {projects
                          .filter(project => 
                            !multiReturnProjectSearch || 
                            project.p_name.toLowerCase().includes(multiReturnProjectSearch.toLowerCase())
                          )
                          .map((project) => (
                            <DropdownItem 
                              key={project.p_id} 
                              onClick={() => {
                                handleMultiReturnProjectChange({ target: { value: project.p_id } });
                                setMultiReturnProjectSearch("");
                              }}
                              style={{ padding: '6px 12px', fontSize: '13px' }}
                            >
                              {project.p_name}
                            </DropdownItem>
                          ))}
                      </DropdownMenu>
                    </Dropdown>
                  </Col>
                  <Col md={6}>
                    <Label for="multiReturnBy">Enter Returned By</Label>
                    <Input
                      type="select"
                      id="multiReturnBy"
                      name="returned_by"
                      value={multiReturn.returned_by}
                      onChange={handleMultiReturnChange}
                      required
                      disabled={!multiReturn.p_id || isMultiReturnUploading}
                    >
                      <option value="">Select Client</option>
                      {multiReturnClients.map((client, idx) => (
                        <option key={idx} value={client}>{client}</option>
                      ))}
                    </Input>
                  </Col>
                </Row>
                <Row className="mb-4">
                  <Col md={6}>
                    <Label for="multiReturnDate">Enter Return Date</Label>
                    <Input
                      type="date"
                      id="multiReturnDate"
                      name="return_date"
                      value={multiReturn.return_date}
                      onChange={handleMultiReturnChange}
                      required
                      disabled={isMultiReturnUploading}
                    />
                  </Col>
                  <Col md={6}>
                    <Label for="multiReturnFile">Upload File (.csv, .xlsx, .xls)</Label>
                    <Input
                      type="file"
                      id="multiReturnFile"
                      name="file"
                      accept=".csv, .xlsx, .xls, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, text/csv"
                      onChange={handleMultiReturnChange}
                      required
                      disabled={isMultiReturnUploading}
                    />
                    {multiReturn.file && (
                      <small className="text-muted mt-1 d-block">
                        Selected file: {multiReturn.file.name}
                      </small>
                    )}
                  </Col>
                </Row>
                <Row>
                  <Col lg="12" style={{ textAlign: "center" }}>
                    <Button
                      style={{ backgroundColor: "#d86f89", borderColor: "#d86f89", color: "black" }}
                      type="submit"
                      disabled={isMultiReturnUploading || !multiReturn.file}
                    >
                      {isMultiReturnUploading ? "Uploading..." : "Submit"}
                    </Button>
                  </Col>
                </Row>
              </Form>
            </ModalBody>
          </Modal>

          <Modal
            isOpen={showReturnDeleteConfirmation}
            toggle={() => setShowReturnDeleteConfirmation(false)}
          >
            <ModalHeader>Confirm Deletion</ModalHeader>
            <ModalBody>
              Are you sure you want to delete this return material?
            </ModalBody>
            <div className="modal-footer">
              <Button color="danger" onClick={handleDeleteReturn}>
                Yes
              </Button>
              <Button
                color="secondary"
                onClick={() => setShowReturnDeleteConfirmation(false)}
              >
                No
              </Button>
            </div>
          </Modal>

          <Modal
            isOpen={showDeliveryDeleteConfirmation}
            toggle={() => setShowDeliveryDeleteConfirmation(false)}
          >
            <ModalHeader>Confirm Deletion</ModalHeader>
            <ModalBody>
              Are you sure you want to delete this material delivery?
            </ModalBody>
            <div className="modal-footer">
              <Button color="danger" onClick={handleDeleteDelivery}>
                Yes
              </Button>
              <Button
                color="secondary"
                onClick={() => setShowDeliveryDeleteConfirmation(false)}
              >
                No
              </Button>
            </div>
          </Modal>
    </>
  );
};

export default Storemanagement4;